(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["babybaraka-name-match-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initBBNM = (scope = document) => {
      const roots = scope.querySelectorAll ? scope.querySelectorAll('[data-bbnm-root]:not([data-bbnm-ready])') : [];

      roots.forEach((root) => {
        root.setAttribute('data-bbnm-ready', 'true');
        const stage = root.querySelector('[data-bbnm-stage]');
        const dataEl = root.querySelector('[data-bbnm-data]');
        if (!stage || !dataEl) return;

        let DATA;
        try { DATA = JSON.parse(dataEl.textContent); } catch (e) { DATA = {}; }

        const paymentIconsTpl = root.querySelector('[data-bbnm-payment-icons]');
        const paymentIconsHtml = paymentIconsTpl ? paymentIconsTpl.innerHTML : "";

        const previewTag = root.querySelector('[data-role="preview-tag"]');
        if (previewTag) previewTag.textContent = DATA.previewTag || "";

        const QUESTIONS = [
          { num: 1, title: "Who are we finding a name for?", sub: "Choose one", max: 1, type: "cards", options: [
            { label: "Girl", emoji: "👧", bg: "#FCE1E8" }, { label: "Boy", emoji: "👦", bg: "#DCEBF8" },
            { label: "Twins", emoji: "👶", bg: "#EAE3F6" }, { label: "We don't know yet", emoji: "🤍", bg: "#FFFFFF" }
          ]},
          { num: 2, title: "Where are you in your baby journey?", sub: "", max: 1, type: "list", options: [
            { label: "Planning ahead", emoji: "🗓️" }, { label: "Pregnant – still have time", emoji: "🤰" },
            { label: "Baby is coming soon", emoji: "🍼" }, { label: "Baby is already here", emoji: "👶" }
          ]},
          { num: 3, title: "Who will be choosing the name with you?", sub: "", max: 1, type: "list", options: [
            { label: "My partner & me", emoji: "❤️" }, { label: "Just me", emoji: "🙂" },
            { label: "My partner", emoji: "🧑" }, { label: "Our family is involved too", emoji: "👨‍👩‍👧" }
          ]},
          { num: 4, title: "Which names feel most like you?", sub: "Choose up to 2", max: 2, type: "list", options: [
            { label: "Soft & modern", emoji: "☁️" }, { label: "Rare but meaningful", emoji: "✨" },
            { label: "Classic & timeless", emoji: "🤎" }, { label: "Strong & distinctive", emoji: "🌙" },
            { label: "Elegant & refined", emoji: "🕊️" }, { label: "Easy internationally", emoji: "🌍" }
          ]},
          { num: 5, title: "Which origins feel closest to your family?", sub: "Choose up to 2", max: 2, type: "list", options: [
            { label: "Arabic" }, { label: "North African / Maghrebi" }, { label: "Turkish / Persian" },
            { label: "South Asian" }, { label: "African" }, { label: "Mixed backgrounds" }, { label: "No preference" }
          ]},
          { num: 6, title: "What would you love your baby's name to express?", sub: "Choose up to 3", max: 3, type: "list", options: [
            { label: "Strength", emoji: "🦁" }, { label: "Kindness", emoji: "🤍" }, { label: "Light & purity", emoji: "🕯️" },
            { label: "Patience", emoji: "🌿" }, { label: "Gratitude", emoji: "🙏" }, { label: "Wisdom", emoji: "🦉" },
            { label: "Justice", emoji: "⚖️" }, { label: "Protection", emoji: "🛡️" }, { label: "Faith", emoji: "🌙" }, { label: "No preference", emoji: "🤍" }
          ]},
          { num: 7, title: "How should the name feel where your child grows up?", sub: "", max: 1, type: "listDesc", options: [
            { label: "Very easy internationally", emoji: "🌍", desc: "Easy in English / French" },
            { label: "A little cultural character is perfect", emoji: "🌿", desc: "A small pronunciation correction is okay" },
            { label: "Arabic comes first", emoji: "🤎", desc: "Authenticity matters more than easy pronunciation" }
          ]},
          { num: 8, title: "Is there a first letter you already love?", sub: "Optional", max: 1, type: "text", placeholder: "Example: A, M, Z…" },
          { num: 9, title: "Any names you already like?", sub: "Add up to 3", max: 3, type: "chips" },
          { num: 10, title: "Any names we should avoid?", sub: "Optional", max: 1, type: "text", placeholder: "Write names here..." },
          { num: 11, title: "What does your partner usually prefer?", sub: "Optional", max: 1, type: "list", options: [
            { label: "Short & modern" }, { label: "Traditional & meaningful" }, { label: "Rare & different" },
            { label: "Easy to pronounce" }, { label: "I'm not really sure" }, { label: "That's the problem – we disagree" }
          ]},
          { num: 12, title: "What matters most when you finally choose?", sub: "Choose 2", max: 2, type: "list", options: [
            { label: "A beautiful meaning" }, { label: "Not too common" },
            { label: "Easy pronunciation" }, { label: "Fits our culture" }, { label: "My partner loves it too" }
          ]},
          { num: 13, title: "What's making the decision hardest right now?", sub: "", max: 1, type: "list", options: [
            { label: "We've seen too many names", emoji: "😵" }, { label: "My partner and I don't agree", emoji: "❤️" },
            { label: "I'm worried about meanings", emoji: "😟" }, { label: "Pronunciation worries me", emoji: "🗣️" },
            { label: "Family opinions make it harder", emoji: "👪" }, { label: "I'm afraid we'll regret our choice", emoji: "😬" },
            { label: "We simply haven't found the one", emoji: "🔍" }
          ]}
        ];
        const OPTIONAL = new Set([8, 10, 11]);

        // The 3 opening-demo names are fixed content, not editable — same
        // convention as the QUESTIONS array above.
        const DEMO_NAMES = [
          { latin: "Suhayl", arabic: "سهيل", meaning: "gentle, the guiding star", why: "Soft on the ear and easy in every accent, but almost nobody in his class will have it. The star sailors once used to find their way home." },
          { latin: "Maryam", arabic: "مريم", meaning: "the devoted one", why: "The only woman named in the Qur'an. Recognised everywhere in Europe, and it carries a clear identity without ever needing to be explained at school." },
          { latin: "Iyad", arabic: "إياد", meaning: "strength and support", why: "Four letters, one clean sound, no spelling to correct for the rest of his life. Strong without being heavy, which is what you asked for." }
        ];

        let state = {
          stage: "demo", // "demo" | "transition" | quiz/ready/landing (driven by step below)
          demoIndex: 0,
          step: 0,
          selections: {},
          texts: {},
          chips: [],
          chipInput: "",
          openFaq: 0
        };
        const esc = (str) => String(str == null ? "" : str).replace(/[&<>"']/g, (ch) => (
          { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[ch]
        ));

        const sel = (n) => state.selections[n] || [];

        // Toggle a single answer within a question's selection list.
        // - Re-clicking a selected option always deselects it.
        // - max <= 1 (single choice) replaces the whole selection.
        // - max > 1 (multi choice) adds up to `max` items; once full, clicking
        //   a new unselected item is a deliberate no-op (must deselect one first).
        function toggle(num, label, max) {
          const current = sel(num).slice();
          const at = current.indexOf(label);
          if (at !== -1) {
            current.splice(at, 1);
          } else if (max <= 1) {
            current.length = 0;
            current.push(label);
          } else if (current.length < max) {
            current.push(label);
          }
          state.selections[num] = current;
          render();
        }

        function addChip() {
          const value = (state.chipInput || "").trim();
          state.chipInput = "";
          if (value && state.chips.length < 3 && state.chips.indexOf(value) === -1) {
            state.chips.push(value);
          }
          render();
        }

        function removeChip(value) {
          state.chips = state.chips.filter((c) => c !== value);
          render();
        }

        function toggleFaq(i) {
          state.openFaq = state.openFaq === i ? -1 : i;
          render();
        }

        function next() {
          if (state.step >= 14) return;
          state.step += 1;
          render();
        }

        function back() {
          if (state.step <= 0) return;
          state.step -= 1;
          render();
        }

        // Opening demo: one round, three fixed names, no partner turn.
        // Any reaction just advances to the next card; after the third,
        // hand off to the transition screen.
        function advanceDemo() {
          state.demoIndex += 1;
          if (state.demoIndex >= DEMO_NAMES.length) {
            state.stage = "transition";
          }
          render();
        }

        // Transition screen's CTA hands off into the existing quiz state
        // machine — step stays at its initial 0, untouched otherwise.
        function startQuiz() {
          state.stage = "quiz";
          render();
        }

        function photoOrPlaceholder(url, height, label) {
          if (url) return `<img class="bbnm-photo" src="${esc(url)}" alt="${esc(label)}" style="height:${height}px">`;
          return `<div class="bbnm-placeholder-img" style="height:${height}px"><span class="emoji">🖼️</span><span>${esc(label)}</span></div>`;
        }

        // A block's video (if set) always wins over its photo: shown as a
        // clickable poster; clicking opens it at real/full size with sound.
        // A plain bonus image is also clickable, opening full size to view.
        function extraCardMedia(x, label) {
          if (x.video && x.video.sources && x.video.sources.length) {
            const posterHtml = x.video.poster
              ? `<img class="bbnm-extra-card-media" src="${esc(x.video.poster)}" alt="${esc(label)}" style="height:210px">`
              : `<div class="bbnm-placeholder-img" style="height:210px"><span class="emoji">🎬</span><span>${esc(label)}</span></div>`;
            return `
              <div class="bbnm-extra-card-media-wrap" data-role="extra-media" data-type="video" data-sources="${esc(JSON.stringify(x.video.sources))}">
                ${posterHtml}
                <div class="bbnm-extra-card-play">▶</div>
              </div>
            `;
          }
          if (x.image) {
            return `
              <div class="bbnm-extra-card-media-wrap" data-role="extra-media" data-type="image" data-image="${esc(x.image)}">
                <img class="bbnm-extra-card-media" src="${esc(x.image)}" alt="${esc(label)}" style="height:230px">
              </div>
            `;
          }
          return `<div class="bbnm-placeholder-img" style="height:230px"><span class="emoji">🖼️</span><span>${esc(label)}</span></div>`;
        }

        function openMediaModal(type, payload) {
          const overlay = document.createElement("div");
          overlay.className = "bbnm-media-modal";
          let mediaEl;
          if (type === "video") {
            mediaEl = document.createElement("video");
            mediaEl.controls = true;
            mediaEl.playsInline = true;
            mediaEl.autoplay = true;
            mediaEl.muted = false;
            payload.forEach((s) => {
              const sourceEl = document.createElement("source");
              sourceEl.src = s.url;
              if (s.type) sourceEl.type = s.type;
              mediaEl.appendChild(sourceEl);
            });
          } else {
            mediaEl = document.createElement("img");
            mediaEl.src = payload;
          }
          const closeBtn = document.createElement("button");
          closeBtn.type = "button";
          closeBtn.className = "bbnm-media-modal-close";
          closeBtn.setAttribute("aria-label", "Close");
          closeBtn.textContent = "✕";
          overlay.appendChild(mediaEl);
          overlay.appendChild(closeBtn);
          document.body.appendChild(overlay);

          function close() {
            if (type === "video") mediaEl.pause();
            overlay.remove();
            document.removeEventListener("keydown", onKeydown);
          }
          function onKeydown(e) {
            if (e.key === "Escape") close();
          }
          closeBtn.addEventListener("click", close);
          overlay.addEventListener("click", (e) => { if (e.target === overlay) close(); });
          document.addEventListener("keydown", onKeydown);

          if (type === "video") mediaEl.play().catch(() => {});
        }

        function renderDemo() {
          const n = DEMO_NAMES[state.demoIndex];
          return `
            <div class="bbnm-demo-head">
              <div class="bbnm-demo-brand">${esc(DATA.demoBrand)}</div>
              <h1 class="bbnm-demo-headline">${esc(DATA.demoHeadline).split("\n").join("<br>")}</h1>
              <p class="bbnm-demo-instruction">${esc(DATA.demoInstruction).split("\n").join("<br>")}</p>
            </div>
            <div class="bbnm-demo-counter">${state.demoIndex + 1}/${DEMO_NAMES.length}</div>
            <div class="bbnm-demo-card tilt-in" data-role="demo-card">
              <div class="bbnm-demo-arabic">${esc(n.arabic)}</div>
              <div class="bbnm-demo-name">${esc(n.latin)}</div>
              <div class="bbnm-demo-meaning">"${esc(n.meaning)}"</div>
              <div class="bbnm-demo-why"><span>Why it fits</span><p>${esc(n.why)}</p></div>
              <div class="bbnm-demo-row">
                <div class="bbnm-reaction bbnm-reaction-no" data-role="demo-react"><div class="bbnm-reaction-icon">✕</div><div class="bbnm-reaction-label">No</div></div>
                <div class="bbnm-reaction bbnm-reaction-maybe" data-role="demo-react"><div class="bbnm-reaction-icon">?</div><div class="bbnm-reaction-label">Maybe</div></div>
                <div class="bbnm-reaction bbnm-reaction-love" data-role="demo-react"><div class="bbnm-reaction-icon">❤</div><div class="bbnm-reaction-label">I Love</div></div>
              </div>
            </div>
          `;
        }

        // Pointer-drag swipe on the demo card: any swipe past the threshold
        // advances (single round, no vote tracking needed); short drags snap
        // back. Re-queried after every render since innerHTML is replaced.
        function wireDemoCard() {
          const card = stage.querySelector('[data-role="demo-card"]');
          if (!card) return;
          let startX = 0, dx = 0, dragging = false;

          card.addEventListener("pointerdown", (e) => {
            dragging = true; startX = e.clientX; dx = 0;
            card.classList.remove("tilt-in", "settle");
            card.setPointerCapture(e.pointerId);
          });
          card.addEventListener("pointermove", (e) => {
            if (!dragging) return;
            dx = e.clientX - startX;
            card.style.transform = `translateX(${dx}px) rotate(${dx * 0.05}deg)`;
          });
          const end = () => {
            if (!dragging) return;
            dragging = false;
            card.classList.add("settle");
            if (Math.abs(dx) > 60) {
              advanceDemo();
              return;
            }
            card.style.transform = "";
          };
          card.addEventListener("pointerup", end);
          card.addEventListener("pointercancel", end);
        }

        function renderTransition() {
          return `
            <div class="bbnm-card">
              <div class="bbnm-content">
                <h1 class="bbnm-transition-title">${esc(DATA.transitionTitle)}</h1>
                <p class="bbnm-transition-body">${esc(DATA.transitionBody)}</p>
                <p class="bbnm-transition-emphasis">${esc(DATA.transitionEmphasis).split("\n").join("<br>")}</p>
              </div>
              <div class="bbnm-footer">
                <button type="button" class="bbnm-continue" data-role="start-quiz">${esc(DATA.transitionCta)}</button>
                <p class="bbnm-transition-note">${esc((DATA.transitionNote || "").replace(/\{price\}/g, DATA.price || ""))}</p>
              </div>
            </div>
          `;
        }

        function renderQuizStep() {
          const q = QUESTIONS[state.step];
          const selected = sel(q.num);
          const progressPct = Math.round((q.num / 13) * 100) + "%";
          let body = "";

          if (q.type === "text") {
            const val = state.texts[q.num] || "";
            const np = selected.includes("No preference");
            body = `
              <input class="bbnm-input" type="text" data-role="answer-text" data-num="${q.num}" placeholder="${esc(q.placeholder)}" value="${esc(val)}">
              <div class="bbnm-nopref${np ? " is-active" : ""}" data-role="no-pref" data-num="${q.num}">No preference</div>
            `;
          } else if (q.type === "chips") {
            const chips = state.chips;
            body = `
              <div class="bbnm-chips">
                ${chips.map((c) => `<div class="bbnm-chip"><span>${esc(c)}</span><span class="bbnm-chip-remove" data-role="chip-remove" data-chip="${esc(c)}">✕</span></div>`).join("")}
              </div>
              <div class="bbnm-chip-row">
                <input class="bbnm-chip-input" type="text" data-role="chip-input" placeholder="Add a name" value="${esc(state.chipInput)}">
                <button type="button" class="bbnm-chip-add" data-role="add-chip">+ Add</button>
              </div>
            `;
          } else {
            const isCard = q.type === "cards";
            body = `<div class="bbnm-options">` + q.options.map((o) => {
              const isSel = selected.includes(o.label);
              const showCheck = isSel && q.max > 1;
              return `
                <div class="bbnm-option${isCard ? " bbnm-option--card" : ""}${isSel ? " is-selected" : ""}" data-role="option" data-num="${q.num}" data-label="${esc(o.label)}" data-max="${q.max}"${isCard ? ` style="background:${o.bg}"` : ""}>
                  ${o.emoji ? `<span class="bbnm-option-emoji">${o.emoji}</span>` : ""}
                  <div class="bbnm-option-body">
                    <div class="bbnm-option-label">${esc(o.label)}</div>
                    ${o.desc ? `<div class="bbnm-option-desc">${esc(o.desc)}</div>` : ""}
                  </div>
                  ${showCheck ? `<span class="bbnm-option-check">✓</span>` : ""}
                </div>
              `;
            }).join("") + `</div>`;
          }

          const canNext = (q.type === "text" || q.type === "chips") ? true : (OPTIONAL.has(q.num) ? true : selected.length > 0);

          return `
            <div class="bbnm-card">
              <div class="bbnm-topbar">
                <button type="button" class="bbnm-back" data-role="back">←</button>
                <div class="bbnm-step-text">Question ${q.num} of 13</div>
                <div></div>
              </div>
              <div class="bbnm-content">
                <h1 class="bbnm-question-title">${esc(q.title)}</h1>
                ${q.sub ? `<p class="bbnm-question-sub">${esc(q.sub)}</p>` : ""}
                ${body}
              </div>
              <div class="bbnm-footer">
                <div class="bbnm-progress"><div class="bbnm-progress-fill" style="width:${progressPct}"></div></div>
                <button type="button" class="bbnm-continue" data-role="next"${canNext ? "" : " disabled"}>Continue</button>
              </div>
            </div>
          `;
        }

        function renderReady() {
          return `
            <div class="bbnm-card bbnm-card--ready">
              <div class="bbnm-ready-emoji">${esc(DATA.readyEmoji)}</div>
              <h1 class="bbnm-ready-title">${esc(DATA.readyTitle)}</h1>
              <p class="bbnm-ready-text">${esc(DATA.readyText)}</p>
              <button type="button" class="bbnm-cta" data-role="next">${esc(DATA.readyCta)}</button>
              <p class="bbnm-ready-note">${esc(DATA.readyNote)}</p>
            </div>
          `;
        }

        function renderLanding() {
          const steps = DATA.steps || [];
          const extras = DATA.extras || [];
          const testimonials = DATA.testimonials || [];
          const faqs = DATA.faqs || [];
          const bullets = DATA.bullets || [];
          const included = DATA.includedList || [];

          const stepsHtml = steps.map((s, i) => `
            <div class="bbnm-step">
              <div class="bbnm-step-num">${i + 1}</div>
              <div style="flex:1">
                <div class="bbnm-step-title">${esc(s.title)}</div>
                <div class="bbnm-step-desc">${esc(s.description)}</div>
                ${photoOrPlaceholder(s.image, 170, s.title || "Step photo")}
              </div>
            </div>
          `).join("");

          const extrasHtml = extras.map((x, i) => `
            <div class="bbnm-extra-card">
              ${extraCardMedia(x, x.title || "Bonus media")}
              <div class="bbnm-extra-card-body">
                <div class="bbnm-extra-badge">${i + 1}</div>
                <div style="flex:1">
                  <div class="bbnm-extra-card-title">${esc(x.title)}</div>
                  <div class="bbnm-extra-card-desc">${esc(x.description)}</div>
                  ${(x.video && x.video.sources && x.video.sources.length) ? `<div class="bbnm-extra-card-caption">▶ Watch the walkthrough</div>` : ""}
                </div>
              </div>
            </div>
          `).join("");

          const testiHtml = testimonials.map((t) => `
            <div class="bbnm-testi">
              <div class="bbnm-testi-text">"${esc(t.quote)}"</div>
              <div class="bbnm-testi-author">— ${esc(t.author)} · <span class="bbnm-hero-stars">★★★★★</span></div>
            </div>
          `).join("");

          const faqItems = faqs.map((f, i) => `
            <div class="bbnm-faq-item" data-role="faq-toggle" data-idx="${i}">
              <div class="bbnm-faq-row">
                <span>${esc(f.q)}</span>
                <span class="bbnm-faq-caret${state.openFaq === i ? " is-open" : ""}">⌄</span>
              </div>
              ${state.openFaq === i ? `<div class="bbnm-faq-answer">${esc(f.a)}</div>` : ""}
            </div>
          `).join("");

          const bulletsHtml = bullets.map((b) => `<div class="bbnm-bullet"><span class="bbnm-bullet-dot">●</span> ${esc(b)}</div>`).join("");
          const includedHtml = included.map((line) => `
            <div class="bbnm-pricing-row">
              <span class="bbnm-pricing-check">✓</span>
              <span class="bbnm-pricing-row-text">${esc(line)}</span>
            </div>
          `).join("");

          const promoHtml = (DATA.promoEnabled && DATA.promoCode) ? `
            <div class="bbnm-block">
              <div class="bbnm-promo">
                <div class="bbnm-promo-badge">${esc(DATA.promoBadge)}</div>
                <p class="bbnm-promo-text">${esc(DATA.promoText)}</p>
                <div class="bbnm-promo-row">
                  <div class="bbnm-promo-code">${esc(DATA.promoCode)}</div>
                  <button type="button" class="bbnm-promo-copy" data-role="promo-copy" data-code="${esc(DATA.promoCode)}">Copy</button>
                </div>
              </div>
            </div>
          ` : "";

          return `
            <div class="bbnm-landing">
              <div class="bbnm-landing-inner">

                <div class="bbnm-hero">
                  <div class="bbnm-hero-brand">${esc(DATA.brandName)}</div>
                  <div class="bbnm-hero-stars">★★★★★</div>
                  <div class="bbnm-hero-rating"><b>5.0/5</b> ${esc(DATA.ratingText)}</div>
                  <h1 class="bbnm-hero-title">${esc(DATA.heroTitle)}</h1>
                  <p class="bbnm-hero-sub">${esc(DATA.heroSubtitle)}</p>

                  ${DATA.heroImage ? `
                  <img class="bbnm-hero-image" src="${esc(DATA.heroImage)}" alt="${esc(DATA.heroAlt)}" style="max-width:${DATA.heroWidth}px;border-radius:${DATA.heroRadius}px">
                  ` : `
                  <div class="bbnm-name-card">
                    <div class="bbnm-name-card-name">${esc(DATA.demoName)}</div>
                    <div class="bbnm-name-card-meaning">${esc(DATA.demoMeaning)}</div>
                    <div class="bbnm-name-card-row">
                      <div class="bbnm-reaction bbnm-reaction-love"><div class="bbnm-reaction-icon">❤</div><div class="bbnm-reaction-label">I Love</div></div>
                      <div class="bbnm-reaction bbnm-reaction-maybe"><div class="bbnm-reaction-icon">?</div><div class="bbnm-reaction-label">Maybe</div></div>
                      <div class="bbnm-reaction bbnm-reaction-no"><div class="bbnm-reaction-icon">✕</div><div class="bbnm-reaction-label">No</div></div>
                    </div>
                  </div>
                  `}

                  <div class="bbnm-bullets">${bulletsHtml}</div>

                  <div class="bbnm-guarantee">
                    <span class="bbnm-guarantee-icon">🛡️</span>
                    <div class="bbnm-guarantee-text"><b>${esc(DATA.guaranteeTitle)}</b><br>${esc(DATA.guaranteeText)}</div>
                  </div>
                </div>

                <div class="bbnm-block bbnm-block--bordered">
                  <h2 class="bbnm-h2">10 names. Two opinions.<br>One shared shortlist. 💗</h2>
                  <div class="bbnm-steps">${stepsHtml}</div>
                  <div class="bbnm-note-box">
                    <span style="font-size:18px">💜</span>
                    <div class="bbnm-note-box-text">Fewer than three shared names? We'll prepare one refinement for free.</div>
                  </div>
                </div>

                <div class="bbnm-block bbnm-block--bordered">
                  <h2 class="bbnm-h2">Plus thoughtful extras 🎁</h2>
                  ${extrasHtml}
                  <div class="bbnm-note-box" style="margin-top:16px">
                    <span style="font-size:18px">⚡</span>
                    <div class="bbnm-note-box-text">${esc(DATA.extrasNote)}</div>
                  </div>
                </div>

                ${promoHtml}

                <div class="bbnm-block bbnm-block--bordered">
                  <div class="bbnm-pricing-badge-row">
                    <div class="bbnm-pricing-badge">${esc(DATA.pricingBadge)}</div>
                  </div>
                  <h2 class="bbnm-h2 bbnm-h2--tight">${esc(DATA.pricingTitle)}</h2>
                  <div class="bbnm-pricing-list">${includedHtml}</div>

                  <div class="bbnm-guarantee" style="margin-top:20px">
                    <span class="bbnm-guarantee-icon">🛡️</span>
                    <div class="bbnm-guarantee-text"><b>${esc(DATA.pricingGuaranteeStrong)}</b>${esc(DATA.pricingGuaranteeRest)}</div>
                  </div>

                  <div class="bbnm-pricing-panel">
                    <div class="bbnm-price-row">
                      <span class="bbnm-price-old">${esc(DATA.priceOld)}</span>
                      <span class="bbnm-price-new">${esc(DATA.price)}</span>
                    </div>
                    <div class="bbnm-price-note">${esc(DATA.priceNote)}</div>
                    <button type="button" class="bbnm-pricing-cta" data-role="get-cta">${esc(DATA.ctaText)} <span>→</span></button>
                    <div class="bbnm-pricing-secure">
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M6 10V8a6 6 0 0 1 12 0v2" stroke="#C6CDDD" stroke-width="2" stroke-linecap="round"/><rect x="4" y="10" width="16" height="10" rx="2.5" fill="#C6CDDD"/></svg>
                      <span>${esc(DATA.pricingSecureNote)}</span>
                    </div>
                    <div class="bbnm-payment-tiles">${paymentIconsHtml}</div>
                  </div>

                  <div class="bbnm-pricing-stats-wrap">
                    <div><b>24h</b>Delivery</div>
                    <div class="bbnm-pricing-stats-divider"></div>
                    <div><b>100%</b>Private</div>
                    <div class="bbnm-pricing-stats-divider"></div>
                    <div><b>Full</b>Refund</div>
                  </div>
                </div>

                <div class="bbnm-block bbnm-block--navy">
                  <div class="bbnm-testi-head">
                    <div class="bbnm-hero-stars">★★★★★</div>
                    <div class="bbnm-testi-head-title">5.0/5 · ${esc(DATA.ratingText)}</div>
                    <div class="bbnm-testi-head-sub">Real families. Real results.</div>
                  </div>
                  <div class="bbnm-testi-list">${testiHtml}</div>
                </div>

                <div class="bbnm-block" style="padding-bottom:44px">
                  <h2 class="bbnm-h2" style="text-align:left">FAQ</h2>
                  ${faqItems}
                </div>

              </div>
            </div>
          `;
        }

        function render() {
          if (state.stage === "demo") {
            stage.innerHTML = renderDemo();
            wireDemoCard();
            return;
          }
          if (state.stage === "transition") { stage.innerHTML = renderTransition(); return; }
          if (state.step < 13) stage.innerHTML = renderQuizStep();
          else if (state.step === 13) stage.innerHTML = renderReady();
          else stage.innerHTML = renderLanding();
        }

        root.addEventListener("click", (event) => {
          const optionEl = event.target.closest('[data-role="option"]');
          if (optionEl) { toggle(Number(optionEl.dataset.num), optionEl.dataset.label, Number(optionEl.dataset.max)); return; }

          const noPrefEl = event.target.closest('[data-role="no-pref"]');
          if (noPrefEl) { toggle(Number(noPrefEl.dataset.num), "No preference", 1); return; }

          const chipRemoveEl = event.target.closest('[data-role="chip-remove"]');
          if (chipRemoveEl) { removeChip(chipRemoveEl.dataset.chip); return; }

          const addChipEl = event.target.closest('[data-role="add-chip"]');
          if (addChipEl) { addChip(); return; }

          const nextEl = event.target.closest('[data-role="next"]');
          if (nextEl) { if (!nextEl.disabled) next(); return; }

          const backEl = event.target.closest('[data-role="back"]');
          if (backEl) { back(); return; }

          const faqEl = event.target.closest('[data-role="faq-toggle"]');
          if (faqEl) { toggleFaq(Number(faqEl.dataset.idx)); return; }

          const getCtaEl = event.target.closest('[data-role="get-cta"]');
          if (getCtaEl) { if (DATA.checkoutUrl) window.location.href = DATA.checkoutUrl; return; }

          const demoReactEl = event.target.closest('[data-role="demo-react"]');
          if (demoReactEl) { advanceDemo(); return; }

          const startQuizEl = event.target.closest('[data-role="start-quiz"]');
          if (startQuizEl) { startQuiz(); return; }

          const copyEl = event.target.closest('[data-role="promo-copy"]');
          if (copyEl) {
            const code = copyEl.dataset.code || "";
            const done = () => { copyEl.textContent = "Copied!"; setTimeout(() => { copyEl.textContent = "Copy"; }, 1800); };
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(code).then(done).catch(done);
            } else {
              done();
            }
            return;
          }

          const extraMediaEl = event.target.closest('[data-role="extra-media"]');
          if (extraMediaEl) {
            if (extraMediaEl.dataset.type === "video") {
              let sources = [];
              try { sources = JSON.parse(extraMediaEl.dataset.sources || "[]"); } catch (e) {}
              openMediaModal("video", sources);
            } else {
              openMediaModal("image", extraMediaEl.dataset.image);
            }
            return;
          }

        });

        root.addEventListener("input", (event) => {
          if (event.target.matches('[data-role="answer-text"]')) {
            state.texts[Number(event.target.dataset.num)] = event.target.value;
            return;
          }
          if (event.target.matches('[data-role="chip-input"]')) {
            state.chipInput = event.target.value;
          }
        });

        root.addEventListener("keydown", (event) => {
          if (event.target.matches('[data-role="chip-input"]') && event.key === "Enter") {
            event.preventDefault();
            addChip();
          }
        });

        render();
      });
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => initBBNM());
    } else {
      initBBNM();
    }

    document.addEventListener("shopify:section:load", (event) => {
      initBBNM(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["babybaraka-name-quiz"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initBabyBarakaQuiz = (scope = document) => {
      const roots = scope.querySelectorAll ? scope.querySelectorAll('[data-bb-quiz-root]:not([data-bb-quiz-ready])') : [];

      roots.forEach((root) => {
        root.setAttribute('data-bb-quiz-ready', 'true');

        // EDIT QUESTIONS HERE.
        // The public funnel keeps the final 11-step BabyBaraka journey.
        // kind: "question" creates a real question.
        // type: "single" allows one answer.
        // type: "multi" allows several answers and keeps every selected card marked.
        // progressStep controls the visible "Step X of 11" number.
        const quizScreens = [
          {
            kind: 'intro',
            progressStep: 1,
            brand: 'BabyBaraka',
            title: "Struggling to Find a Meaningful Muslim Name for Your Baby?",
            text: "Take our free 2-minute quiz and discover how BabyBaraka can personally prepare 10 meaningful names matched to your preferences, values and family.",
            footnote: 'Takes less than 2 minutes',
            button: 'Start My Free Quiz'
          },
          {
            kind: 'question',
            id: 'babyType',
            progressStep: 1,
            type: 'single',
            question: 'Who are you looking for a name for?',
            helper: 'Choose one',
            options: ['Baby girl', 'Baby boy', 'Twins / two babies', "We don't know yet"]
          },
          {
            kind: 'question',
            id: 'babyJourney',
            progressStep: 2,
            type: 'single',
            helper: 'Choose one',
            question: 'Where are you in your baby journey?',
            options: ['Planning for the future', 'Pregnant and still have time', 'Baby is coming soon', 'Baby is already here']
          },
          {
            kind: 'question',
            id: 'nameStyles',
            progressStep: 3,
            type: 'multi',
            max: 2,
            helper: 'Choose up to two',
            maxMessage: 'You can choose up to two.',
            question: 'Which name style feels closest to you?',
            options: ['Soft and modern', 'Classic and timeless', 'Rare but meaningful', 'Easy to use internationally', 'Elegant and refined']
          },
          {
            kind: 'question',
            id: 'origins',
            progressStep: 4,
            type: 'multi',
            max: 2,
            helper: 'Choose up to two',
            maxMessage: 'You can choose up to two.',
            question: 'Which origins would you like us to focus on?',
            options: ['Arabic', 'North African / Maghrebi', 'Turkish or Persian', 'South Asian', 'African', 'Mixed origins', 'No preference']
          },
          {
            kind: 'note',
            progressStep: 5,
            title: 'A beautiful sound is only the beginning.',
            text: "The right name should have a beautiful sound, a clear meaning and feel natural in your family's everyday life. Your next answers help us understand exactly what you are looking for.",
            button: 'Continue'
          },
          {
            kind: 'question',
            id: 'priorities',
            progressStep: 6,
            type: 'multi',
            max: 2,
            helper: 'Choose up to two',
            maxMessage: 'You can choose up to two.',
            question: 'What matters most to you in a name?',
            options: ['A beautiful meaning', 'A beautiful sound', 'Easy pronunciation', 'Something both parents love', 'A balance of everything']
          },
          {
            kind: 'question',
            id: 'meaningPreferences',
            progressStep: 7,
            type: 'multi',
            max: 2,
            helper: 'Choose up to two',
            maxMessage: 'You can choose up to two.',
            question: 'Which meanings are you most drawn to?',
            options: ['Faith and guidance', 'Strength and courage', 'Mercy and kindness', 'Peace and wisdom', 'Beauty and grace', 'No specific preference']
          },
          {
            kind: 'question',
            id: 'difficulties',
            progressStep: 8,
            type: 'multi',
            helper: 'Select all that apply.',
            question: 'What is making the name decision hardest right now?',
            options: ['Too many lists, I feel lost', "I don't fully trust meanings online", 'My husband or family disagrees', "I want an Islamic name that's also easy to carry in the West", 'I want something rare, not random']
          },
          {
            kind: 'question',
            id: 'avoidances',
            progressStep: 9,
            type: 'multi',
            helper: 'Select all that apply.',
            question: 'What do you most want to avoid?',
            options: ['Choosing a name with the wrong meaning', 'Regretting the name later', 'My child always correcting pronunciation', 'More arguments with family', 'Choosing something too common']
          },
          {
            kind: 'letterPreference',
            id: 'initialPreferences',
            progressStep: 10,
            question: "Do you have any letter preferences for your baby's name?",
            helper: 'Choose one',
            options: [
              { value: 'preferred', label: "Yes, I'd like it to start with a specific letter" },
              { value: 'avoided', label: "Yes, I'd like to avoid a specific letter" },
              { value: 'none', label: "No, I don't have a letter preference" }
            ]
          },
          {
            kind: 'note',
            progressStep: 10,
            title: 'The problem is not finding more names.',
            text: 'The real challenge is knowing which names genuinely fit your baby. Your answers now give us enough direction to understand the origin, sound and priorities that matter to you.',
            button: 'Continue'
          },
          {
            kind: 'note',
            progressStep: 11,
            title: 'We Understand What You Are Looking For.',
            text: "Your personalized direction is ready, based on everything you just shared.",
            button: 'See My Personalized Direction'
          }
        ];

        const nameCatalog = {
          female: {
            arabic: ['Aaliyah','Amina','Amira','Aya','Basma','Bushra','Dana','Dima','Duha','Emaan','Farah','Hala','Hana','Hiba','Hind','Iman','Inaya','Isra','Jana','Jannah','Jumana','Kawthar','Laila','Lama','Lina','Lujain','Maha','Malak','Mariam','Marwa','Nada','Nadine','Noor','Rahma','Rania','Reem','Rima','Ruqayya','Safa','Salma','Sana','Sarah','Shatha','Sumayya','Tasneem','Yara','Yasmin','Zahra','Zaynab','Rasha'],
            turkish_persian: ['Aylin','Duru','Elif','Eylul','Hazal','Ilayda','Irmak','Meryem','Miray','Nisa','Selin','Zeynep','Azra','Esra','Hira','Irem','Leyla','Melek','Nehir','Nisan','Asel','Alara','Beren','Ceyda','Defne','Ecrin','Melis','Mina','Parisa','Yasna'],
            maghrebi: ['Kenza','Ines','Nesrine','Lyna','Sirine','Amel','Nawel','Widad','Souad','Mouna','Samira','Soraya','Lamia','Ghita','Houda','Ikram','Meriem','Nawal','Rym','Sabah','Dounia','Alya','Noura','Imane','Chaima'],
            south_asian: ['Aafiya','Anaya','Arisha','Eshal','Fariha','Haniya','Mahira','Meher','Mishal','Naira','Nimra','Rida','Sabeen','Saira','Zoya','Zunaira','Areeba','Iqra','Kinza','Mahnoor'],
            african: ['Abena','Aminata','Assia','Binta','Faduma','Hawa','Kadija','Kumba','Mariama','Nala','Nia','Safiya','Yacine','Zuri','Imani']
          },
          male: {
            arabic: ['Adam','Adil','Ahmad','Akram','Ali','Amir','Anas','Ayman','Bilal','Elias','Faris','Hamza','Haris','Hassan','Haytham','Ibrahim','Idris','Ilyas','Imran','Ismail','Iyad','Jad','Jamal','Karim','Khalil','Laith','Luay','Malik','Marwan','Mazen','Mounir','Musa','Nabil','Nadir','Nael','Omar','Qasim','Rami','Rayyan','Saad','Sami','Samir','Tariq','Taha','Yasin','Yusuf','Zaid','Zayn','Zakariya','Ziyad'],
            turkish_persian: ['Alp','Aras','Ayaz','Baran','Berat','Burak','Can','Cihan','Demir','Deniz','Emir','Emre','Eren','Kaan','Kerem','Mert','Miran','Onur','Ozan','Selim','Sinan','Timur','Tolga','Umut','Yaman','Arman','Darius','Kian','Navid','Rayan'],
            maghrebi: ['Aksel','Anis','Ayoub','Badr','Chafik','Djibril','Elyes','Fares','Hakim','Hichem','Idir','Ilian','Islem','Kamel','Lyes','Mehdi','Naim','Nassim','Nouh','Reda','Sofiane','Walid','Wassim','Yanis','Younes'],
            south_asian: ['Ayaan','Aariz','Affan','Arham','Danish','Faizan','Huzaifa','Junaid','Ruhan','Rehan','Rishan','Saif','Shahzaib','Shayan','Uzair','Zayan','Zubair','Aahil','Daniyal','Arsal'],
            african: ['Abdou','Amadou','Bakary','Cheikh','Demba','Ibrahima','Khalifa','Mamadou','Moussa','Ousmane','Sekou','Souleymane','Tidiane','Yacouba','Zuberi']
          }
        };

        const resultTypes = {
          soft: {
            title: 'Soft Faith-Fit Names',
            copy: 'You are drawn to a gentle name style: warm, modern, Muslim-friendly, and easy for your child to carry in daily life.',
            reassurance: 'BabyBaraka gives personalized guidance with meaning checked as carefully as possible, while keeping origin, pronunciation, family context, and faith-fit in view.'
          },
          classic: {
            title: 'Classic Islamic Names',
            copy: 'Your answers point toward timeless names with a strong Muslim identity, familiar roots, and a calm sense of tradition.',
            reassurance: 'BabyBaraka is not an imam, scholar, or fatwa service. The goal is personalized guidance, not religious certainty, with meanings checked as carefully as possible.'
          },
          rare: {
            title: 'Rare Meaningful Names',
            copy: 'You seem to want something special and less common, but not random: a name with beauty, meaning, and a thoughtful origin.',
            reassurance: 'Instead of giving you another endless list, BabyBaraka helps narrow the direction so the names feel meaningful, Muslim-friendly, and usable in real life.'
          },
          international: {
            title: 'Easy International Muslim-Friendly Names',
            copy: 'Your style is practical and thoughtful: Muslim-friendly names that are beautiful, easy to pronounce, and comfortable across cultures.',
            reassurance: 'BabyBaraka considers pronunciation, sound, meaning, origin, and family context so the final shortlist feels easier to carry with confidence.'
          },
          balanced: {
            title: 'Premium Balanced Shortlist',
            copy: 'You want the full picture: meaning, faith-fit, beauty, pronunciation, family peace, and a name that feels right for your baby.',
            reassurance: 'BabyBaraka turns scattered ideas into personalized guidance, with a shortlist designed to bring clarity instead of more overwhelm.'
          }
        };

        const offers = {
          basic: {
            title: 'Basic',
            subtitle: '5 Personalized Names',
            description: 'A focused shortlist with meaning and origin, delivered by email in 24-48h.',
            button: 'Choose Basic',
            priceKey: 'basicPrice',
            variantKey: 'basicVariantId',
            urlKey: 'basicProductUrl'
          },
          premium: {
            title: 'Premium',
            subtitle: '10 Personalized Names + 1 Refinement + Milestone Printables',
            badge: 'Most Recommended',
            description: 'Best choice for parents who want more confidence, more options, one refinement, and a beautiful digital milestone bonus.',
            button: 'Choose Premium',
            priceKey: 'premiumPrice',
            variantKey: 'premiumVariantId',
            urlKey: 'premiumProductUrl'
          },
          duo: {
            title: 'Duo / Twins',
            subtitle: '20 Personalized Names',
            description: 'For twins, two babies, or parents who want a complete naming direction.',
            button: 'Choose Duo/Twins',
            priceKey: 'duoPrice',
            variantKey: 'duoVariantId',
            urlKey: 'duoProductUrl'
          }
        };

        const forcedSalesPagePath = '/pages/babybaraka-offer';

        const config = {
          distractionFree: root.dataset.distractionFree === 'true',
          redirectToSales: true,
          salesPageUrl: forcedSalesPagePath,
          enableAddToCart: root.dataset.enableAddToCart === 'true',
          destination: root.dataset.variantDestination || 'checkout',
          basicVariantId: root.dataset.basicVariantId || '',
          premiumVariantId: root.dataset.premiumVariantId || '',
          duoVariantId: root.dataset.duoVariantId || '',
          basicProductUrl: root.dataset.basicProductUrl || '',
          premiumProductUrl: root.dataset.premiumProductUrl || '',
          duoProductUrl: root.dataset.duoProductUrl || '',
          basicPrice: root.dataset.basicPrice || '$14.99',
          premiumPrice: root.dataset.premiumPrice || '$24.99',
          duoPrice: root.dataset.duoPrice || '$34.99',
          resultButtonText: root.dataset.resultButtonText || 'View My Personalized Options',
          milestonePreviewUrl: root.dataset.milestonePreviewUrl || 'https://cdn.shopify.com/s/files/1/0927/5487/0596/files/milestones-preview-3-cards.png?v=1782151578'
        };
        const totalSteps = 11;
        const progressPercents = [0, 9, 18, 27, 36, 45, 55, 64, 73, 82, 91, 100];
        const salesTargetUrl = new URL(forcedSalesPagePath, window.location.origin);
        const isSalesPagePath = salesTargetUrl.origin === window.location.origin
          && normalizePath(salesTargetUrl.pathname) === normalizePath(window.location.pathname);

        if (isSalesPagePath) {
          root.hidden = true;
          root.style.display = 'none';
          document.body.classList.remove('bb-quiz-distraction-free');
          return;
        }

        if (config.distractionFree) {
          document.body.classList.add('bb-quiz-distraction-free');
        }

        const stage = root.querySelector('[data-bb-quiz-stage]');
        const backButton = root.querySelector('[data-bb-quiz-back]');
        const progressFill = root.querySelector('[data-bb-quiz-progress-fill]');
        const stepText = root.querySelector('[data-bb-quiz-step-text]');
        const percentText = root.querySelector('[data-bb-quiz-percent]');
        const storageKey = 'bb-name-quiz-' + (root.dataset.bbQuizSectionId || 'default');

        let state = loadState();
        let screenIndex = Number.isInteger(state.screenIndex) ? state.screenIndex : 0;
        let answers = state.answers || {};
        let lead = state.lead || {};
        let resultKey = state.resultKey || '';
        let recommendedOffer = state.recommendedOffer || '';
        let isCompletingQuiz = false;

        root.addEventListener('click', (event) => {
          const resultButton = event.target.closest('[data-bb-quiz-scroll-offers]');
          if (!resultButton) return;
          event.preventDefault();
          completeQuizAndRedirect();
        });

        function loadState() {
          try {
            return JSON.parse(localStorage.getItem(storageKey)) || {};
          } catch (error) {
            return {};
          }
        }

        function saveState() {
          try {
            const nextState = {
              screenIndex,
              answers,
              lead,
              resultKey,
              recommendedOffer
            };
            localStorage.setItem(storageKey, JSON.stringify(nextState));
            localStorage.setItem('bb-name-quiz-latest', JSON.stringify(nextState));
            localStorage.setItem('babybaraka_quiz_answers', JSON.stringify(buildOfferPayload()));
          } catch (error) {
            // Some browsers block localStorage. The quiz still works during the session.
          }
        }

        function firstValue(id) {
          return answerList(id)[0] || '';
        }

        function labelToSlug(value) {
          return String(value || '')
            .toLowerCase()
            .replace(/&/g, 'and')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
        }

        function resultTitleFromKey(key) {
          return (resultTypes[key] || resultTypes.balanced).title;
        }

        function buildOfferPayload() {
          const styles = answerList('nameStyles');
          const key = resultKey || determineResult();
          return {
            firstName: lead.firstName || '',
            email: lead.email || '',
            babyType: labelToSlug(firstValue('babyType')),
            babyJourney: labelToSlug(firstValue('babyJourney')),
            nameStyles: styles.map(labelToSlug),
            origins: answerList('origins').map(labelToSlug),
            priorities: answerList('priorities').map(labelToSlug),
            meaningPreferences: answerList('meaningPreferences').map(labelToSlug),
            difficulties: answerList('difficulties').map(labelToSlug),
            avoidances: answerList('avoidances').map(labelToSlug),
            initialPreferenceType: String(answers.initialPreferenceType || ''),
            initialPreferences: String(answers.initialPreferences || ''),
            primaryStyle: labelToSlug(styles[0] || ''),
            secondaryStyle: labelToSlug(styles[1] || ''),
            resultTitle: resultTitleFromKey(key),
            completedAt: new Date().toISOString(),
            rawAnswers: answers
          };
        }

        function escapeHTML(value) {
          return String(value || '').replace(/[&<>"']/g, (character) => ({
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#039;'
          }[character]));
        }

        function answerList(id) {
          const value = answers[id];
          return Array.isArray(value) ? value : value ? [value] : [];
        }

        function hasAnswer(id, value) {
          return answerList(id).includes(value);
        }

        function updateProgress(screen, isResult) {
          const step = isResult ? totalSteps : (screen && screen.progressStep ? screen.progressStep : 1);
          const percent = isResult ? 100 : (progressPercents[step] || Math.round((step / totalSteps) * 100));
          progressFill.style.width = percent + '%';
          stepText.textContent = isResult ? 'Your results' : 'Step ' + step + ' of ' + totalSteps;
          percentText.textContent = percent + '%';
          backButton.hidden = screenIndex <= 0 || isResult;
        }

        function render() {
          const screen = quizScreens[screenIndex];

          if (!screen) {
            completeQuizAndRedirect();
            return;
          }

          updateProgress(screen, false);

          if (screen.kind === 'intro') renderIntro(screen);
          if (screen.kind === 'question') renderQuestion(screen);
          if (screen.kind === 'letterPreference') renderLetterPreference(screen);
          if (screen.kind === 'note') renderNote(screen);
          if (screen.kind === 'capture') renderCapture(screen);

          saveState();
        }

        function renderIntro(screen) {
          stage.innerHTML = `
            <div class="bb-quiz-screen bb-quiz-intro">
              <div class="bb-quiz-brand">
                <span class="bb-quiz-brand-mark" aria-hidden="true">${moonIcon()}</span>
                <span>${escapeHTML(screen.brand)}</span>
              </div>
              <h1 class="bb-quiz-title">${escapeHTML(screen.title)}</h1>
              <p class="bb-quiz-subtitle">${escapeHTML(screen.text)}</p>
              <div class="bb-quiz-hero-art" aria-hidden="true"></div>
              <div class="bb-quiz-actions">
                <button class="bb-quiz-button" type="button" data-bb-quiz-continue>${escapeHTML(screen.button)}</button>
                ${screen.footnote ? `<p class="bb-quiz-small-note">${escapeHTML(screen.footnote)}</p>` : ''}
              </div>
            </div>
          `;

          stage.querySelector('[data-bb-quiz-continue]').addEventListener('click', () => {
            screenIndex += 1;
            render();
          });
        }

        function renderMilestonePreview() {
          const imageUrl = String(config.milestonePreviewUrl || '').trim();
          const fallbackCards = `
            <div class="bb-quiz-milestone-fallback" aria-label="Milestone card examples">
              <span class="bb-quiz-mini-milestone"><span>Alhamdulillah</span><strong>One</strong><small>MONTH OLD</small></span>
              <span class="bb-quiz-mini-milestone"><span>My First</span><strong>Smile</strong><small>MILESTONE</small></span>
              <span class="bb-quiz-mini-milestone"><span>Bismillah</span><strong>I'm Here</strong><small>NEW BABY</small></span>
            </div>
          `;

          return `
            <div class="bb-quiz-milestone-preview">
              ${imageUrl
                ? `<img src="${escapeHTML(imageUrl)}" alt="Example of BabyBaraka printable milestone cards" loading="lazy">`
                : fallbackCards}
              <p class="bb-quiz-milestone-caption">Example bonus: soft Islamic milestone cards for baby's first moments.</p>
            </div>
          `;
        }

        function renderQuestion(screen) {
          const selected = answerList(screen.id);
          const helper = screen.helper || 'Choose the answer that feels closest.';
          const milestonePreview = screen.id === 'milestones' ? renderMilestonePreview() : '';
          const optionHTML = screen.options.map((option) => {
            const isSelected = selected.includes(option);
            return `
              <button class="bb-quiz-option${isSelected ? ' bb-quiz-selected' : ''}" type="button" data-bb-quiz-answer="${escapeHTML(option)}" aria-pressed="${isSelected ? 'true' : 'false'}">
                <span class="bb-quiz-icon" aria-hidden="true">${optionIcon(option)}</span>
                <span class="bb-quiz-option-label">${escapeHTML(option)}</span>
                <span class="bb-quiz-check" aria-hidden="true">${checkIcon()}</span>
                <span class="bb-quiz-sparkle" aria-hidden="true"></span>
              </button>
            `;
          }).join('');

          stage.innerHTML = `
            <div class="bb-quiz-screen bb-quiz-question-screen">
              <h2 class="bb-quiz-question">${escapeHTML(screen.question)}</h2>
              <p class="bb-quiz-helper">${escapeHTML(helper)}</p>
              ${milestonePreview}
              ${screen.maxMessage ? `<p class="bb-quiz-small-note" data-bb-quiz-limit hidden>${escapeHTML(screen.maxMessage)}</p>` : ''}
              <div class="bb-quiz-options">${optionHTML}</div>
              <div class="bb-quiz-actions">
                <button class="bb-quiz-button" type="button" data-bb-quiz-continue ${selected.length ? '' : 'disabled'}>Continue</button>
              </div>
            </div>
          `;

          stage.querySelectorAll('[data-bb-quiz-answer]').forEach((button) => {
            button.addEventListener('click', (event) => {
              const value = button.dataset.bbQuizAnswer;
              const current = answerList(screen.id);
              addRipple(button, event);

              if (screen.type === 'multi') {
                const max = Number(screen.max || 0);
                if (max && !current.includes(value) && current.length >= max) {
                  const helperEl = stage.querySelector('[data-bb-quiz-limit]');
                  if (helperEl) {
                    helperEl.hidden = false;
                    helperEl.classList.remove('bb-quiz-pop');
                    window.requestAnimationFrame(() => helperEl.classList.add('bb-quiz-pop'));
                  }
                  return;
                }
                answers[screen.id] = current.includes(value)
                  ? current.filter((item) => item !== value)
                  : current.concat(value);
              } else {
                answers[screen.id] = [value];
              }

              saveState();
              renderQuestion(screen);

              const selectedButton = stage.querySelector('[data-bb-quiz-answer="' + cssEscape(value) + '"]');
              if (selectedButton) {
                selectedButton.classList.remove('bb-quiz-pop');
                window.requestAnimationFrame(() => selectedButton.classList.add('bb-quiz-pop'));
              }
            });
          });

          stage.querySelector('[data-bb-quiz-continue]').addEventListener('click', () => {
            if (!answerList(screen.id).length) return;
            screenIndex += 1;
            render();
          });
        }

        function renderNote(screen) {
          stage.innerHTML = `
            <div class="bb-quiz-screen bb-quiz-card-note">
              <div class="bb-quiz-card-note-inner">
                <span class="bb-quiz-card-icon" aria-hidden="true">${heartCircleIcon()}</span>
                <h2 class="bb-quiz-note-title">${escapeHTML(screen.title)}</h2>
                <p class="bb-quiz-note-copy">${escapeHTML(screen.text)}</p>
                <div class="bb-quiz-actions">
                  <button class="bb-quiz-button" type="button" data-bb-quiz-continue>${escapeHTML(screen.button)}</button>
                </div>
              </div>
            </div>
          `;

          stage.querySelector('[data-bb-quiz-continue]').addEventListener('click', () => {
            screenIndex += 1;
            render();
          });
        }

        function renderLetterPreference(screen) {
          const selectedType = String(answers.initialPreferenceType || '');
          const currentValue = String(answers.initialPreferences || '');
          const needsLetter = selectedType === 'preferred' || selectedType === 'avoided';
          const inputLabel = selectedType === 'avoided'
            ? 'Which letter or letters would you like us to avoid?'
            : 'Which letter or letters would you prefer?';
          const optionHTML = screen.options.map((option) => `
            <button class="bb-quiz-option${selectedType === option.value ? ' bb-quiz-selected' : ''}" type="button" data-bb-letter-choice="${escapeHTML(option.value)}" aria-pressed="${selectedType === option.value ? 'true' : 'false'}">
              <span class="bb-quiz-icon" aria-hidden="true">${option.value === 'none' ? '✓' : 'A'}</span>
              <span class="bb-quiz-option-label">${escapeHTML(option.label)}</span>
              <span class="bb-quiz-check" aria-hidden="true">${checkIcon()}</span>
            </button>
          `).join('');
          stage.innerHTML = `
            <div class="bb-quiz-screen bb-quiz-question-screen">
              <h2 class="bb-quiz-question">${escapeHTML(screen.question)}</h2>
              <p class="bb-quiz-helper">${escapeHTML(screen.helper || '')}</p>
              <div class="bb-quiz-options">${optionHTML}</div>
              ${needsLetter ? `
                <div class="bb-quiz-field">
                  <label for="bb-quiz-letter-${escapeHTML(screen.id)}">${escapeHTML(inputLabel)}</label>
                  <input id="bb-quiz-letter-${escapeHTML(screen.id)}" data-bb-letter-input type="text" maxlength="40" placeholder="For example: A, M or S" value="${escapeHTML(currentValue)}">
                </div>
              ` : ''}
              <div class="bb-quiz-actions">
                <button class="bb-quiz-button" type="button" data-bb-letter-continue ${selectedType && (!needsLetter || currentValue.trim()) ? '' : 'disabled'}>Continue</button>
              </div>
            </div>
          `;

          stage.querySelectorAll('[data-bb-letter-choice]').forEach((button) => {
            button.addEventListener('click', () => {
              answers.initialPreferenceType = button.dataset.bbLetterChoice;
              if (answers.initialPreferenceType === 'none') answers.initialPreferences = '';
              saveState();
              renderLetterPreference(screen);
            });
          });

          const input = stage.querySelector('[data-bb-letter-input]');
          if (input) {
            input.addEventListener('input', () => {
              answers.initialPreferences = String(input.value || '').trim();
              const continueButton = stage.querySelector('[data-bb-letter-continue]');
              continueButton.disabled = !answers.initialPreferences;
              saveState();
            });
          }

          stage.querySelector('[data-bb-letter-continue]').addEventListener('click', () => {
            if (!answers.initialPreferenceType) return;
            if (answers.initialPreferenceType !== 'none' && !String(answers.initialPreferences || '').trim()) return;
            screenIndex += 1;
            render();
          });
        }

        function renderCapture(screen) {
          stage.innerHTML = `
            <div class="bb-quiz-screen bb-quiz-capture">
              <h2 class="bb-quiz-capture-title">${escapeHTML(screen.title)}</h2>
              <p class="bb-quiz-copy">${escapeHTML(screen.text)}</p>
              <form class="bb-quiz-form" data-bb-quiz-form>
                <div class="bb-quiz-field">
                  <label for="bb-quiz-name-${escapeHTML(root.dataset.bbQuizSectionId || 'default')}">First name</label>
                  <input id="bb-quiz-name-${escapeHTML(root.dataset.bbQuizSectionId || 'default')}" name="first_name" type="text" autocomplete="given-name" placeholder="Amina" value="${escapeHTML(lead.firstName || '')}" required>
                </div>
                <div class="bb-quiz-field">
                  <label for="bb-quiz-email-${escapeHTML(root.dataset.bbQuizSectionId || 'default')}">Email</label>
                  <input id="bb-quiz-email-${escapeHTML(root.dataset.bbQuizSectionId || 'default')}" name="email" type="email" autocomplete="email" placeholder="you@example.com" value="${escapeHTML(lead.email || '')}" required>
                </div>
                <p class="bb-quiz-safe-note">Your answers are safe with us.</p>
                <button class="bb-quiz-button" type="submit">${escapeHTML(screen.button)}</button>
              </form>
            </div>
          `;

          stage.querySelector('[data-bb-quiz-form]').addEventListener('submit', (event) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            lead = {
              firstName: String(formData.get('first_name') || '').trim(),
              email: String(formData.get('email') || '').trim()
            };
            resultKey = determineResult();
            recommendedOffer = determineOffer();
            completeQuizAndRedirect();
          });
        }

        function determineResult() {
          if (hasAnswer('nameStyles', 'Classic and timeless') || hasAnswer('meaningPreferences', 'Faith and guidance')) return 'classic';
          if (hasAnswer('nameStyles', 'Rare but meaningful') || hasAnswer('difficulties', 'I want something rare, not random') || hasAnswer('avoidances', 'Choosing something too common')) return 'rare';
          if (hasAnswer('nameStyles', 'Easy to use internationally') || hasAnswer('priorities', 'Easy pronunciation') || hasAnswer('difficulties', "I want an Islamic name that's also easy to carry in the West") || hasAnswer('avoidances', 'My child always correcting pronunciation')) return 'international';
          if (hasAnswer('nameStyles', 'Soft and modern') || hasAnswer('nameStyles', 'Elegant and refined') || hasAnswer('priorities', 'A beautiful sound')) return 'soft';
          return 'balanced';
        }

        function determineOffer() {
          if (hasAnswer('babyType', 'Twins / two babies')) return 'duo';
          return 'premium';
        }

        function selectedOriginKeys() {
          const selected = answerList('origins');
          const keys = [];
          if (selected.includes('Arabic')) keys.push('arabic');
          if (selected.includes('North African / Maghrebi')) keys.push('maghrebi');
          if (selected.includes('Turkish or Persian')) keys.push('turkish_persian');
          if (selected.includes('South Asian')) keys.push('south_asian');
          if (selected.includes('African')) keys.push('african');
          return keys.length ? keys : ['arabic', 'maghrebi', 'turkish_persian', 'south_asian', 'african'];
        }

        function stableQuizNumber() {
          const seed = JSON.stringify({
            babyType: answerList('babyType'),
            nameStyles: answerList('nameStyles'),
            origins: answerList('origins'),
            priorities: answerList('priorities'),
            meanings: answerList('meaningPreferences'),
            avoidances: answerList('avoidances')
          });
          let hash = 2166136261;
          for (let index = 0; index < seed.length; index += 1) {
            hash ^= seed.charCodeAt(index);
            hash = Math.imul(hash, 16777619);
          }
          return Math.abs(hash);
        }

        function catalogNames(gender) {
          const catalog = nameCatalog[gender];
          const names = selectedOriginKeys().flatMap((key) => catalog[key] || []);
          return Array.from(new Set(names));
        }

        function originForName(gender, name) {
          const catalog = nameCatalog[gender];
          const entry = Object.keys(catalog).find((key) => catalog[key].includes(name)) || 'arabic';
          return {
            arabic: 'Arabic origin',
            maghrebi: 'Maghrebi connection',
            turkish_persian: 'Turkish / Persian origin',
            south_asian: 'South Asian usage',
            african: 'African Muslim usage'
          }[entry];
        }

        function styleReason() {
          return firstValue('nameStyles') || {
            classic: 'Classic and timeless',
            rare: 'Rare but meaningful',
            international: 'Easy internationally',
            soft: 'Soft and modern',
            balanced: 'Balanced choice'
          }[determineResult()];
        }

        function priorityReason() {
          const priorities = answerList('priorities');
          if (priorities.includes('Easy pronunciation')) return 'Easy to pronounce';
          if (priorities.includes('A beautiful meaning')) return 'Meaning-led choice';
          if (priorities.includes('Something both parents love')) return 'Family-friendly fit';
          if (priorities.includes('A beautiful sound')) return 'Beautiful sound';
          return 'Matches your priorities';
        }

        function nameMatch(gender, offset) {
          const names = catalogNames(gender);
          const styleOffsets = { classic: 3, soft: 11, rare: 23, international: 37, balanced: 47 };
          const index = (stableQuizNumber() + styleOffsets[determineResult()] + offset) % names.length;
          const name = names[index];
          return {
            name,
            reasons: [styleReason(), originForName(gender, name), priorityReason()]
          };
        }

        function selectPersonalizedMatches() {
          const babyType = firstValue('babyType');
          let matches;
          if (babyType === 'Baby girl') {
            matches = [nameMatch('female', 0), nameMatch('female', 17)];
          } else if (babyType === 'Baby boy') {
            matches = [nameMatch('male', 0), nameMatch('male', 17)];
          } else {
            matches = [nameMatch('female', 0), nameMatch('male', 17)];
          }
          if (matches[0].name === matches[1].name) matches[1] = nameMatch(babyType === 'Baby boy' ? 'male' : 'female', 31);
          return matches;
        }

        function renderResult() {
          redirectToSalesPage();
          return;

          const key = resultKey || determineResult();
          const result = resultTypes[key] || resultTypes.balanced;
          const offerKey = recommendedOffer || determineOffer();
          updateProgress(null, true);

          stage.innerHTML = `
            <div class="bb-quiz-screen bb-quiz-result">
              <div class="bb-quiz-result-card">
                <span class="bb-quiz-result-mark" aria-hidden="true">${heartCircleIcon()}</span>
                <span class="bb-quiz-result-eyebrow">Your Name Style Is</span>
                <h2 class="bb-quiz-result-title">${escapeHTML(result.title)}</h2>
                <p class="bb-quiz-result-copy">${escapeHTML(result.copy)}</p>
                <p class="bb-quiz-result-reassurance">${escapeHTML(result.reassurance)}</p>
                <div class="bb-quiz-result-action">
                  <button class="bb-quiz-button" type="button" data-bb-quiz-scroll-offers>${escapeHTML(config.resultButtonText)}</button>
                </div>
              </div>
              <div id="bb-quiz-offers-${escapeHTML(root.dataset.bbQuizSectionId || 'default')}">
                <h3 class="bb-quiz-offer-heading">Choose Your Personalized Shortlist</h3>
                <p class="bb-quiz-offer-subheading">Choose the option that fits your needs best.</p>
              </div>
              <div class="bb-quiz-offers">
                ${Object.keys(offers).map((keyName) => renderOffer(keyName, offers[keyName], keyName === offerKey)).join('')}
              </div>
              <p class="bb-quiz-error" data-bb-quiz-error>Please add a variant ID or product URL for this offer in the Shopify theme editor.</p>
              <div class="bb-quiz-trust">
                <span>${lockIcon()} Meaning checked as carefully as possible</span>
                <span>${heartIcon()} Personalized, not random</span>
                <span>${mailIcon()} Delivered by email in 24-48h</span>
                <span>${moonIcon()} Muslim-friendly guidance</span>
                <span>${lockIcon()} Your data is safe and private</span>
              </div>
              <p class="bb-quiz-footer-line">No guesswork. No endless lists. Just the right names for your baby.</p>
              <p class="bb-quiz-footer-subline">Let BabyBaraka help you give your baby their first blessing with confidence.</p>
            </div>
          `;

          const scrollButton = stage.querySelector('[data-bb-quiz-scroll-offers]');
          if (scrollButton) {
            scrollButton.addEventListener('click', () => {
              const offersTitle = stage.querySelector('#bb-quiz-offers-' + cssEscape(root.dataset.bbQuizSectionId || 'default'));
              if (offersTitle) offersTitle.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
          }

          stage.querySelectorAll('[data-bb-quiz-offer]').forEach((button) => {
            button.addEventListener('click', () => selectOffer(button.dataset.bbQuizOffer, button));
          });

          stage.querySelectorAll('[data-bb-quiz-offer-card]').forEach((card) => {
            card.addEventListener('click', (event) => {
              if (event.target.closest('[data-bb-quiz-offer]')) return;
              const actionButton = card.querySelector('[data-bb-quiz-offer]');
              selectOffer(card.dataset.bbQuizOfferCard, actionButton || card);
            });
            card.addEventListener('keydown', (event) => {
              if (event.key !== 'Enter' && event.key !== ' ') return;
              event.preventDefault();
              const actionButton = card.querySelector('[data-bb-quiz-offer]');
              selectOffer(card.dataset.bbQuizOfferCard, actionButton || card);
            });
          });

          saveState();
        }

        function renderOffer(key, offer, isRecommended) {
          return `
            <article class="bb-quiz-offer${isRecommended ? ' bb-quiz-recommended' : ''}" role="button" tabindex="0" data-bb-quiz-offer-card="${escapeHTML(key)}">
              ${offer.badge ? `<span class="bb-quiz-badge">${escapeHTML(offer.badge)}</span>` : ''}
              <h4 class="bb-quiz-offer-title">${escapeHTML(offer.title)}</h4>
              <span class="bb-quiz-offer-subtitle">${escapeHTML(offer.subtitle)}</span>
              <strong class="bb-quiz-offer-price">${escapeHTML(config[offer.priceKey])}</strong>
              <p class="bb-quiz-offer-desc">${escapeHTML(offer.description)}</p>
              <button class="bb-quiz-button bb-quiz-offer-button${isRecommended ? '' : ' bb-quiz-secondary-button'}" type="button" data-bb-quiz-offer="${escapeHTML(key)}">${escapeHTML(offer.button)}</button>
            </article>
          `;
        }

        function cartAttributes(offerKey) {
          const activeResult = resultTypes[resultKey || determineResult()] || resultTypes.balanced;
          return {
            'BabyBaraka quiz result': activeResult.title,
            'BabyBaraka offer': offers[offerKey].title,
            'BabyBaraka first name': lead.firstName || '',
            'BabyBaraka email': lead.email || '',
            'BabyBaraka baby': answerList('babyType').join(', '),
            'BabyBaraka journey': answerList('babyJourney').join(', '),
            'BabyBaraka style': answerList('nameStyles').join(', '),
            'BabyBaraka origins': answerList('origins').join(', '),
            'BabyBaraka priorities': answerList('priorities').join(', '),
            'BabyBaraka meaning': answerList('meaningPreferences').join(', '),
            'BabyBaraka concern': answerList('difficulties').join(', '),
            'BabyBaraka avoid': answerList('avoidances').join(', '),
            'BabyBaraka initials': String(answers.initialPreferences || ''),
            'BabyBaraka letter preference type': String(answers.initialPreferenceType || ''),
            'BabyBaraka milestones': answerList('milestones').join(', ')
          };
        }

        function quizLeadMessage(offerKey) {
          const attrs = cartAttributes(offerKey);
          return [
            'New BabyBaraka quiz lead',
            '',
            'First name: ' + (lead.firstName || ''),
            'Email: ' + (lead.email || ''),
            '',
            'Quiz result: ' + attrs['BabyBaraka quiz result'],
            'Recommended offer: ' + attrs['BabyBaraka offer'],
            '',
            'Baby: ' + attrs['BabyBaraka baby'],
            'Journey: ' + attrs['BabyBaraka journey'],
            'Style: ' + attrs['BabyBaraka style'],
            'Origins: ' + attrs['BabyBaraka origins'],
            'Priorities: ' + attrs['BabyBaraka priorities'],
            'Meaning: ' + attrs['BabyBaraka meaning'],
            'Concern: ' + attrs['BabyBaraka concern'],
            'Avoid: ' + attrs['BabyBaraka avoid'],
            'Preferred or avoided initials: ' + attrs['BabyBaraka initials'],
            'Milestones: ' + attrs['BabyBaraka milestones'],
            '',
            'Status: Quiz completed, payment not confirmed yet.'
          ].join('\n');
        }

        async function submitQuizLeadToShopify() {
          if (!lead.email) return false;

          try {
            const formspreeOfferKey = recommendedOffer || determineOffer();
            const formspreeAttrs = cartAttributes(formspreeOfferKey);
            const formspreeBody = new FormData();
            formspreeBody.append('_subject', 'New BabyBaraka quiz lead');
            formspreeBody.append('created_at', new Date().toISOString());
            formspreeBody.append('first_name', lead.firstName || '');
            formspreeBody.append('email', lead.email || '');
            formspreeBody.append('quiz_result', formspreeAttrs['BabyBaraka quiz result']);
            formspreeBody.append('recommended_offer', formspreeAttrs['BabyBaraka offer']);
            formspreeBody.append('baby_type', formspreeAttrs['BabyBaraka baby']);
            formspreeBody.append('baby_journey', formspreeAttrs['BabyBaraka journey']);
            formspreeBody.append('style', formspreeAttrs['BabyBaraka style']);
            formspreeBody.append('priorities', formspreeAttrs['BabyBaraka priorities']);
            formspreeBody.append('concern', formspreeAttrs['BabyBaraka concern']);
            formspreeBody.append('avoid', formspreeAttrs['BabyBaraka avoid']);
            formspreeBody.append('looked_where', answerList('looked_where').join(', '));
            formspreeBody.append('milestones', answerList('milestones').join(', '));
            formspreeBody.append('help_wanted', answerList('help').join(', '));
            formspreeBody.append('paid_status', 'not_paid_yet');
            formspreeBody.append('source_url', window.location.href);
            formspreeBody.append('full_message', quizLeadMessage(formspreeOfferKey));

            await Promise.race([
              fetch('https://formspree.io/f/xpqgrerq', {
                method: 'POST',
                body: formspreeBody,
                mode: 'no-cors',
                keepalive: true
              }),
              new Promise((resolve) => window.setTimeout(resolve, 1600))
            ]);

            return true;

            const makeOfferKey = recommendedOffer || determineOffer();
            const makeAttrs = cartAttributes(makeOfferKey);
            const makeBody = new URLSearchParams();
            makeBody.append('created_at', new Date().toISOString());
            makeBody.append('first_name', lead.firstName || '');
            makeBody.append('email', lead.email || '');
            makeBody.append('quiz_result', makeAttrs['BabyBaraka quiz result']);
            makeBody.append('recommended_offer', makeAttrs['BabyBaraka offer']);
            makeBody.append('baby_type', makeAttrs['BabyBaraka baby']);
            makeBody.append('baby_journey', makeAttrs['BabyBaraka journey']);
            makeBody.append('style', makeAttrs['BabyBaraka style']);
            makeBody.append('priorities', makeAttrs['BabyBaraka priorities']);
            makeBody.append('concern', makeAttrs['BabyBaraka concern']);
            makeBody.append('avoid', makeAttrs['BabyBaraka avoid']);
            makeBody.append('looked_where', answerList('looked_where').join(', '));
            makeBody.append('milestones', answerList('milestones').join(', '));
            makeBody.append('help_wanted', answerList('help').join(', '));
            makeBody.append('paid_status', 'not_paid_yet');
            makeBody.append('source_url', window.location.href);
            makeBody.append('full_message', quizLeadMessage(makeOfferKey));

            await Promise.race([
              fetch('https://hook.eu1.make.com/bmkjq4nkdyigq5u4vjf3f3695t5tg84k', {
                method: 'POST',
                body: makeBody.toString(),
                mode: 'no-cors',
                keepalive: true
              }),
              new Promise((resolve) => window.setTimeout(resolve, 1600))
            ]);

            return true;

            const offerKey = recommendedOffer || determineOffer();
            const body = new URLSearchParams();
            body.append('form_type', 'contact');
            body.append('utf8', '✓');
            body.append('contact[name]', lead.firstName || 'BabyBaraka quiz lead');
            body.append('contact[email]', lead.email);
            body.append('contact[tags]', 'babybaraka-quiz-lead,quiz-completed');
            body.append('contact[body]', quizLeadMessage(offerKey));

            const request = fetch('/contact', {
              method: 'POST',
              headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
              body: body.toString(),
              credentials: 'same-origin'
            });

            const response = await Promise.race([
              request,
              new Promise((resolve) => window.setTimeout(() => resolve(null), 1600))
            ]);

            return !response || response.ok;
          } catch (error) {
            // Lead capture is helpful, but it should never block the funnel.
            return false;
          }
        }

        function urlWithQuizParams(url, offerKey) {
          const target = new URL(url, window.location.origin);
          const attrs = cartAttributes(offerKey);
          target.searchParams.set('quiz_result', attrs['BabyBaraka quiz result']);
          target.searchParams.set('selected_offer', attrs['BabyBaraka offer']);
          target.searchParams.set('baby_type', attrs['BabyBaraka baby']);
          target.searchParams.set('style', attrs['BabyBaraka style']);
          return target.toString();
        }

        function normalizePath(path) {
          return String(path || '').replace(/\/+$/, '') || '/';
        }

        function salesPageUrlWithQuizParams() {
          const offerKey = recommendedOffer || determineOffer();
          const target = new URL(forcedSalesPagePath, window.location.origin);
          const attrs = cartAttributes(offerKey);
          const matches = selectPersonalizedMatches();
          target.searchParams.set('quiz_result', attrs['BabyBaraka quiz result']);
          target.searchParams.set('selected_offer', attrs['BabyBaraka offer']);
          target.searchParams.set('baby_type', attrs['BabyBaraka baby']);
          target.searchParams.set('style', attrs['BabyBaraka style']);
          target.searchParams.set('priority', attrs['BabyBaraka priorities']);
          target.searchParams.set('concern', attrs['BabyBaraka concern']);
          target.searchParams.set('priorities', attrs['BabyBaraka priorities']);
          target.searchParams.set('origins', attrs['BabyBaraka origins']);
          target.searchParams.set('meaning_preferences', attrs['BabyBaraka meaning']);
          target.searchParams.set('difficulties', attrs['BabyBaraka concern']);
          target.searchParams.set('avoidances', attrs['BabyBaraka avoid']);
          target.searchParams.set('initial_preferences', attrs['BabyBaraka initials']);
          target.searchParams.set('journey', attrs['BabyBaraka journey']);
          target.searchParams.set('baby_journey', attrs['BabyBaraka journey']);
          target.searchParams.set('bb_quiz_done', '1');
          target.searchParams.set('bb_name_1', matches[0].name);
          target.searchParams.set('bb_name_2', matches[1].name);
          matches.forEach((match, nameIndex) => {
            match.reasons.forEach((reason, reasonIndex) => {
              target.searchParams.set(`bb_reason_${nameIndex + 1}_${reasonIndex + 1}`, reason);
            });
          });
          try {
            localStorage.setItem('babybaraka_quiz_matches', JSON.stringify({
              bb_name_1: matches[0].name,
              bb_name_2: matches[1].name,
              bb_reason_1_1: matches[0].reasons[0],
              bb_reason_1_2: matches[0].reasons[1],
              bb_reason_1_3: matches[0].reasons[2],
              bb_reason_2_1: matches[1].reasons[0],
              bb_reason_2_2: matches[1].reasons[1],
              bb_reason_2_3: matches[1].reasons[2],
              style: attrs['BabyBaraka style'],
              origins: attrs['BabyBaraka origins'],
              priority: attrs['BabyBaraka priorities'],
              avoidances: attrs['BabyBaraka avoid']
            }));
          } catch (error) {}
          return target.toString();
        }

        async function completeQuizAndRedirect() {
          if (isCompletingQuiz) return;
          isCompletingQuiz = true;
          resultKey = resultKey || determineResult();
          recommendedOffer = recommendedOffer || determineOffer();
          screenIndex = quizScreens.length;
          saveState();

          const targetUrl = salesPageUrlWithQuizParams();
          stage.innerHTML = `
            <div class="bb-quiz-screen bb-quiz-card-note">
              <div class="bb-quiz-card-note-inner">
                <span class="bb-quiz-card-icon" aria-hidden="true">${sparkleIcon()}</span>
                <h2 class="bb-quiz-note-title">Preparing your personalized name style...</h2>
                <p class="bb-quiz-note-copy">One moment, we are taking you to your BabyBaraka results.</p>
              </div>
            </div>
          `;

          window.setTimeout(() => {
            window.location.assign(targetUrl);
            window.setTimeout(() => {
              window.location.href = targetUrl;
            }, 260);
          }, 80);
        }

        function redirectToSalesPage() {
          completeQuizAndRedirect();
        }

        async function selectOffer(offerKey, button) {
          const offer = offers[offerKey];
          const variantId = String(config[offer.variantKey] || '').trim();
          const productUrl = String(config[offer.urlKey] || '').trim();
          const error = stage.querySelector('[data-bb-quiz-error]');

          if (error) error.classList.remove('bb-quiz-show');

          if (config.enableAddToCart && variantId) {
            const oldText = button.textContent;
            button.disabled = true;
            button.textContent = 'Adding...';

            try {
              const attributes = cartAttributes(offerKey);
              const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({
                  id: Number(variantId),
                  quantity: 1,
                  properties: Object.assign({}, attributes, {
                    '_BabyBaraka quiz': 'Name style quiz'
                  })
                })
              });

              if (!response.ok) throw new Error('Add to cart failed');

              await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ attributes })
              });

              window.location.href = config.destination === 'cart' ? '/cart' : '/checkout';
              return;
            } catch (event) {
              button.disabled = false;
              button.textContent = oldText;
              if (productUrl) {
                window.location.href = urlWithQuizParams(productUrl, offerKey);
                return;
              }
              if (error) error.classList.add('bb-quiz-show');
              return;
            }
          }

          if (productUrl) {
            window.location.href = urlWithQuizParams(productUrl, offerKey);
            return;
          }

          if (variantId) {
            window.location.href = '/cart/' + encodeURIComponent(variantId) + ':1' + (config.destination === 'cart' ? '' : '?checkout');
            return;
          }

          if (error) error.classList.add('bb-quiz-show');
        }

        function cssEscape(value) {
          if (window.CSS && CSS.escape) return CSS.escape(value);
          return String(value).replace(/["\\]/g, '\\$&');
        }

        function addRipple(button, event) {
          const rect = button.getBoundingClientRect();
          const ripple = document.createElement('span');
          const x = event && event.clientX ? event.clientX - rect.left : rect.width / 2;
          const y = event && event.clientY ? event.clientY - rect.top : rect.height / 2;
          ripple.className = 'bb-quiz-ripple';
          ripple.style.left = x + 'px';
          ripple.style.top = y + 'px';
          button.appendChild(ripple);
          window.setTimeout(() => ripple.remove(), 560);
        }

        function optionIcon(option) {
          const text = option.toLowerCase();
          let emoji = '✨';
          if (text.includes('girl')) emoji = '🎀';
          else if (text.includes('boy')) emoji = '⭐';
          else if (text.includes('twin') || text.includes('two')) emoji = '👶👶';
          else if (text.includes('sure') || text.includes('maybe')) emoji = '❔';
          else if (text.includes('soft') || text.includes('beautiful') || text.includes('love')) emoji = '🤎';
          else if (text.includes('classic') || text.includes('islamic') || text.includes('imam') || text.includes('identity')) emoji = '🌙';
          else if (text.includes('rare')) emoji = '💎';
          else if (text.includes('pronounce') || text.includes('international') || text.includes('west') || text.includes('carry')) emoji = '🌍';
          else if (text.includes('meaning') || text.includes('trust') || text.includes('google')) emoji = '🔎';
          else if (text.includes('family') || text.includes('husband') || text.includes('parents')) emoji = '👨‍👩‍👧';
          else if (text.includes('pregnant') || text.includes('started')) emoji = '🌱';
          else if (text.includes('coming soon')) emoji = '⏳';
          else if (text.includes('already here')) emoji = '👶';
          else if (text.includes('tiktok') || text.includes('instagram') || text.includes('planning')) emoji = '✨';
          else if (text.includes('apps')) emoji = '📲';
          else if (text.includes('wrong')) emoji = '⚠️';
          else if (text.includes('regretting')) emoji = '💭';
          else if (text.includes('correcting')) emoji = '🗣️';
          else if (text.includes('common')) emoji = '🔁';
          else if (text.includes('short list') || text.includes('focused')) emoji = '📝';
          else if (text.includes('deeper')) emoji = '⭐';
          else if (text.includes('yes')) emoji = '🎀';
          return '<span class="bb-quiz-emoji" aria-hidden="true">' + emoji + '</span>';
        }

        function checkIcon() {
          return '<svg viewBox="0 0 24 24"><path d="m6 12 4 4 8-9"></path></svg>';
        }

        function moonIcon() {
          return '<svg viewBox="0 0 24 24"><path d="M15.6 3.4A8.5 8.5 0 1 0 20.6 14 6.4 6.4 0 0 1 15.6 3.4Z"></path><path d="M18 5.5l.4 1.1 1.1.4-1.1.4L18 8.5l-.4-1.1-1.1-.4 1.1-.4L18 5.5Z"></path></svg>';
        }

        function heartIcon() {
          return '<svg viewBox="0 0 24 24"><path d="M12 21c-4-2.7-7-5.5-7-9.2A4.7 4.7 0 0 1 12 7a4.7 4.7 0 0 1 7 4.8c0 3.7-3 6.5-7 9.2Z"></path></svg>';
        }

        function heartCircleIcon() {
          return '<svg viewBox="0 0 24 24"><path d="M12 21c-4-2.7-7-5.5-7-9.2A4.7 4.7 0 0 1 12 7a4.7 4.7 0 0 1 7 4.8c0 3.7-3 6.5-7 9.2Z"></path><path d="M3 12a9 9 0 1 0 18 0 9 9 0 0 0-18 0Z"></path></svg>';
        }

        function sparkleIcon() {
          return '<svg viewBox="0 0 24 24"><path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3Z"></path><path d="M19 15l.7 2.3L22 18l-2.3.7L19 21l-.7-2.3L16 18l2.3-.7L19 15Z"></path></svg>';
        }

        function starIcon() {
          return '<svg viewBox="0 0 24 24"><path d="m12 3 2.7 5.5 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.8 1-6.1-4.4-4.3 6.1-.9L12 3Z"></path></svg>';
        }

        function peopleIcon() {
          return '<svg viewBox="0 0 24 24"><path d="M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"></path><path d="M15 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"></path><path d="M4 20a5 5 0 0 1 10 0"></path><path d="M10 20a5 5 0 0 1 10 0"></path></svg>';
        }

        function questionIcon() {
          return '<svg viewBox="0 0 24 24"><path d="M9.4 9a3 3 0 0 1 5.8 1.1c0 2.4-3.2 2.5-3.2 5"></path><path d="M12 19h.01"></path><path d="M3 12a9 9 0 1 0 18 0 9 9 0 0 0-18 0Z"></path></svg>';
        }

        function globeIcon() {
          return '<svg viewBox="0 0 24 24"><path d="M3 12a9 9 0 1 0 18 0 9 9 0 0 0-18 0Z"></path><path d="M3.6 9h16.8"></path><path d="M3.6 15h16.8"></path><path d="M12 3a14 14 0 0 1 0 18"></path><path d="M12 3a14 14 0 0 0 0 18"></path></svg>';
        }

        function lockIcon() {
          return '<svg viewBox="0 0 24 24"><path d="M7 11V8a5 5 0 0 1 10 0v3"></path><rect x="5" y="11" width="14" height="10" rx="2"></rect><path d="M12 15v2"></path></svg>';
        }

        function mailIcon() {
          return '<svg viewBox="0 0 24 24"><rect x="3" y="6" width="18" height="12" rx="1.5"></rect><path d="m3 7 9 7 9-7"></path></svg>';
        }

        backButton.addEventListener('click', () => {
          if (screenIndex <= 0) return;
          screenIndex -= 1;
          render();
        });

        if (screenIndex >= quizScreens.length) {
          screenIndex = 0;
          answers = {};
          lead = {};
          resultKey = '';
          recommendedOffer = '';
          saveState();
        }

        screenIndex = Math.min(screenIndex, quizScreens.length - 1);
        render();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initBabyBarakaQuiz());
    } else {
      initBabyBarakaQuiz();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initBabyBarakaQuiz(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["babybaraka-offer-image-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clean = (value) => value ? value.replace(/\+/g, ' ').replace(/[|_]+/g, ', ').replace(/\s*,\s*/g, ', ').trim() : '';
    const init = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const params = new URLSearchParams(window.location.search);
      const config = JSON.parse(root.querySelector('[data-bb-config]').textContent);
      const fields = {
        result: clean(params.get('quiz_result') || params.get('style')),
        meaning: clean(params.get('meaning_preferences')),
        origin: clean(params.get('origins')),
        avoid: clean(params.get('avoidances'))
      };
      const orderAnswers = Object.fromEntries(Object.entries({
        'BabyBaraka quiz result': clean(params.get('quiz_result')),
        'BabyBaraka selected offer': clean(params.get('selected_offer')),
        'BabyBaraka baby': clean(params.get('baby_type')),
        'BabyBaraka journey': clean(params.get('journey') || params.get('baby_journey')),
        'BabyBaraka style': clean(params.get('style')),
        'BabyBaraka origins': clean(params.get('origins')),
        'BabyBaraka priorities': clean(params.get('priorities') || params.get('priority')),
        'BabyBaraka meaning': clean(params.get('meaning_preferences')),
        'BabyBaraka concern': clean(params.get('difficulties') || params.get('concern')),
        'BabyBaraka avoid': clean(params.get('avoidances')),
        'BabyBaraka initials': clean(params.get('initial_preferences'))
      }).filter(([, value]) => value));
      const mappings = [
        ['[data-bb-style]', fields.result],
        ['[data-bb-meaning]', fields.meaning],
        ['[data-bb-origin]', fields.origin],
        ['[data-bb-avoid]', fields.avoid]
      ];
      mappings.forEach(([selector, value]) => {
        const node = root.querySelector(selector);
        if (node && value) node.textContent = value;
      });
      const heroResult = root.querySelector('[data-bb-result]');
      if (heroResult && fields.result) heroResult.textContent = fields.result.replace(/\s+Names$/i, '').trim();
      root.querySelectorAll('[data-bb-card]').forEach((card) => {
        const key = card.dataset.bbCard;
        if (!fields[key] && key !== 'meaning') card.hidden = true;
      });
      const resultCopy = root.querySelector('[data-bb-result-copy]');
      if (resultCopy && fields.result) {
        const direction = fields.result.replace(/\s+Names$/i, '').trim().toLowerCase();
        resultCopy.textContent = `You’re looking for something ${direction} — now let’s turn your preferences into a shortlist made around what matters to your family.`;
      }
      const error = root.querySelector('[data-bb-error]');
      const previewDialog = root.querySelector('[data-bb-preview-dialog]');
      const previewImage = root.querySelector('[data-bb-preview-image]');
      root.querySelectorAll('[data-bb-preview]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const image = trigger.querySelector('img');
          if (!previewDialog || !previewImage || !image) return;
          previewImage.src = image.currentSrc || image.src;
          previewImage.alt = image.alt;
          previewDialog.showModal();
        });
      });
      root.querySelector('[data-bb-preview-close]')?.addEventListener('click', () => previewDialog?.close());
      previewDialog?.addEventListener('click', (event) => {
        if (event.target === previewDialog) previewDialog.close();
      });
      const sticky = root.querySelector('[data-bb-sticky]');
      const shortlist = root.querySelector('.bb-shortlist__pages');
      const bonuses = root.querySelector('.bb-bonus-swipe');
      if (sticky && shortlist && bonuses) {
        const updateSticky = () => {
          const shortlistTop = shortlist.getBoundingClientRect().top;
          const bonusesTop = bonuses.getBoundingClientRect().top;
          sticky.classList.toggle('is-on', shortlistTop <= window.innerHeight * .65 && bonusesTop > window.innerHeight * .25);
        };
        window.addEventListener('scroll', updateSticky, { passive: true });
        updateSticky();
      }
      root.querySelectorAll('[data-bb-buy]').forEach((button) => {
        button.addEventListener('click', async () => {
          const variantId = Number(config.variantId);
          if (!variantId) return;
          const original = button.innerHTML;
          button.disabled = true;
          button.textContent = 'Opening secure checkout…';
          try {
            await fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
            const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: variantId, quantity: 1, properties: orderAnswers }) });
            if (!response.ok) throw new Error('Cart error');
            window.location.href = '/checkout';
          } catch (event) {
            button.disabled = false;
            button.innerHTML = original;
            error.textContent = 'Something went wrong. Please try again.';
            error.classList.add('is-visible');
          }
        });
      });
    };
    document.querySelectorAll('[data-bb-image-offer]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-bb-image-offer]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["babybaraka-offer-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const boot = (root) => {
      if (!root || root.dataset.bbv2Ready === '1') return;
      root.dataset.bbv2Ready = '1';
      const p = new URLSearchParams(window.location.search);
      const keys = ['quiz_result','style','origins','priorities','priority','meaning_preferences','avoidances','difficulties','journey','baby_journey','baby_type','bb_quiz_done'];
      const hasCtx = keys.some((k) => p.has(k));

      const set = (sel, text) => { const n = root.querySelector(sel); if (n) n.textContent = text; };

      if (!hasCtx) {
        root.querySelectorAll('[data-bbv2-personal]').forEach((n) => { n.hidden = true; });
        const badge = root.querySelector('[data-bbv2-badge]');
        if (badge) badge.hidden = true;
        const quizlink = root.querySelector('[data-bbv2-quizlink]');
        if (quizlink) quizlink.hidden = false;
        set('[data-bbv2-eyebrow]', 'A personalized shortlist of');
        set('[data-bbv2-result]', 'Muslim Baby Names That Truly Fit');
        set('[data-bbv2-lead]', 'Ten names chosen around your taste, values, origins and everyday life — each with its meaning, origin and the reason it fits your family.');
        set('[data-bbv2-note]', 'Answer a few questions and we build the shortlist around you.');
        set('[data-bbv2-scrolltext]', 'See what you receive');
        set('[data-bbv2-bridge-kicker]', 'The real problem');
        const bridgeTitle = root.querySelector('[data-bbv2-bridge-title]');
        if (bridgeTitle) bridgeTitle.innerHTML = 'You don’t need more names. <em>You need the right ones.</em>';
        set('[data-bbv2-receive-title]', 'Your preferences, turned into 10 real names');
        set('[data-bbv2-receive-sub]', 'Each one chosen around your answers — with its meaning, origin, and why it fits your family.');
        return;
      }

      const result = p.get('quiz_result');
      if (result) set('[data-bbv2-result]', result);

      const leadFor = (r) => {
        const s = (r || '').toLowerCase();
        if (s.includes('classic') && s.includes('rare')) return 'You are looking for names that feel timeless and meaningful, yet distinctive enough to feel truly yours.';
        if (s.includes('classic')) return 'You are looking for names that feel meaningful, Muslim-friendly, easy to pronounce, and beautiful to carry in real life.';
        if (s.includes('rare')) return 'You are looking for names that feel distinctive and meaningful, without ever feeling invented or hard to carry.';
        if (s.includes('international')) return 'You are looking for names that honour your faith and still feel natural to pronounce wherever your child grows up.';
        if (s.includes('soft')) return 'You are looking for names that feel gentle, meaningful and easy for your child to carry every day.';
        return 'You are looking for names that feel meaningful, Muslim-friendly, easy to pronounce, and beautiful to carry in real life.';
      };
      set('[data-bbv2-lead]', leadFor(result));

      const first = (...names) => {
        for (const n of names) { const v = p.get(n); if (v) return v; }
        return '';
      };
      const rows = [
        ['☆', 'Name style', first('style','quiz_result')],
        ['♡', 'What matters most', first('priorities','priority')],
        ['◎', 'Origins you want', first('origins')],
        ['✧', 'Meanings you love', first('meaning_preferences')],
        ['✕', 'What to avoid', first('avoidances','difficulties')],
        ['☾', 'Baby journey', first('journey','baby_journey')]
      ].filter((r) => r[2]);

      const recap = root.querySelector('[data-bbv2-recap]');
      const recapCard = root.querySelector('.bbv2-recap');
      if (recap && rows.length) {
        if (recapCard) recapCard.hidden = false;
        rows.forEach(([icon, label, value], i) => {
          const row = document.createElement('div');
          row.className = 'bbv2-recap__row';
          const ic = document.createElement('span');
          ic.className = 'bbv2-recap__ico';
          ic.setAttribute('aria-hidden', 'true');
          ic.textContent = icon;
          const box = document.createElement('div');
          const st = document.createElement('strong');
          st.textContent = (i + 1) + '. ' + label;
          const vl = document.createElement('span');
          vl.className = 'v';
          vl.textContent = value;
          box.append(st, vl);
          row.append(ic, box);
          recap.appendChild(row);
        });
      }

      const tagBox = root.querySelector('[data-bbv2-tags]');
      const tagCard = root.querySelector('.bbv2-tags');
      if (tagBox) {
        const seen = new Set();
        [first('quiz_result'), first('style'), first('priorities','priority'), first('origins')]
          .filter(Boolean)
          .flatMap((v) => v.split(','))
          .map((v) => v.trim())
          .filter(Boolean)
          .forEach((v) => {
            const k = v.toLowerCase();
            if (seen.has(k) || seen.size >= 5) return;
            seen.add(k);
            const tag = document.createElement('i');
            tag.textContent = v;
            tagBox.appendChild(tag);
          });
        if (tagCard && seen.size) tagCard.hidden = false;
      }

      root.querySelectorAll('a[href*="/cart/"]').forEach((a) => {
        try {
          const u = new URL(a.getAttribute('href'), window.location.origin);
          keys.concat(['first_name','email']).forEach((k) => {
            const v = p.get(k);
            if (v) u.searchParams.set('attributes[' + k + ']', v);
          });
          a.setAttribute('href', u.pathname + u.search);
        } catch (e) {}
      });
    };

    const extras = (root) => {
      const sticky = root.querySelector('[data-bbv2-sticky]');
      const anchor = root.querySelector('.bbv2-receive');
      const bonuses = root.querySelector('.bbv2-bonuses');
      if (sticky && anchor && bonuses) {
        const updateSticky = () => {
          const shortlistTop = anchor.getBoundingClientRect().top;
          const bonusesTop = bonuses.getBoundingClientRect().top;
          sticky.classList.toggle('is-on', shortlistTop <= window.innerHeight * .65 && bonusesTop > window.innerHeight * .25);
        };
        window.addEventListener('scroll', updateSticky, { passive: true });
        updateSticky();
      }
      const modal = root.querySelector('[data-bbv2-modal]');
      const modalVideo = root.querySelector('[data-bbv2-modal-video]');
      const closeModal = () => {
        if (!modal || !modalVideo) return;
        modalVideo.pause();
        modalVideo.removeAttribute('src');
        modal.hidden = true;
      };
      root.querySelectorAll('[data-bbv2-play]').forEach((btn) => {
        btn.addEventListener('click', () => {
          if (!modal || !modalVideo) return;
          modalVideo.src = btn.getAttribute('data-bbv2-play');
          modal.hidden = false;
          modalVideo.play().catch(() => {});
        });
      });
      const closeBtn = root.querySelector('[data-bbv2-close]');
      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      if (modal) modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeModal(); });
    };

    const init = (root) => { if (!root) return; boot(root); extras(root); };
    document.querySelectorAll('[data-bbv2]').forEach(init);
    document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-bbv2]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["babybaraka-post-quiz-offer"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.bb-offer').forEach((section) => {
    const config = JSON.parse(section.querySelector('[data-bb-config]').textContent);
    const tabs = section.querySelectorAll('[data-bb-tab]');
    const panels = section.querySelectorAll('[data-bb-panel]');
    const toast = section.querySelector('.bb-toast');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const index = tab.dataset.bbTab;
        tabs.forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach((panel) => {
          const active = panel.dataset.bbPanel === index;
          panel.classList.toggle('is-active', active);
          const video = panel.querySelector('video');
          if (video && !active) video.pause();
        });
      });
    });

    section.querySelectorAll('[data-bb-buy]').forEach((button) => {
      button.addEventListener('click', async () => {
        if (!config.variantId) {
          toast.textContent = 'Select the offer product in the theme editor.';
          toast.classList.add('is-visible');
          window.setTimeout(() => toast.classList.remove('is-visible'), 3500);
          return;
        }

        const original = button.innerHTML;
        button.disabled = true;
        button.textContent = 'Adding your package…';

        try {
          const response = await fetch(config.addUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: config.variantId, quantity: 1 }] })
          });
          if (!response.ok) throw new Error('Cart error');
          window.location.href = config.checkoutUrl;
        } catch (error) {
          button.disabled = false;
          button.innerHTML = original;
          toast.textContent = 'Something went wrong. Please try again.';
          toast.classList.add('is-visible');
          window.setTimeout(() => toast.classList.remove('is-visible'), 3500);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["babybaraka-quiz-result"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.bbReady === 'true') return;
      root.dataset.bbReady = 'true';
      const params = new URLSearchParams(window.location.search);
      const result = params.get('quiz_result');
      const content = root.querySelector('[data-bb-result-content]');
      const fallback = root.querySelector('[data-bb-result-fallback]');
      if (!result) {
        if (fallback) fallback.hidden = false;
        return;
      }
      root.classList.add('is-revealing');
      if (content) content.hidden = false;
      const resultProfiles = {
        soft: {
          icon: '\u263e',
          validation: 'Your style reflects a gentle kind of confidence. You are drawn to names that feel warm, faith-conscious and easy for your child to carry every day.',
          traits: ['Warm & gentle', 'Faith-fit', 'Easy to carry']
        },
        classic: {
          icon: '\u2726',
          validation: 'Your style says a lot about you \u2014 you care about meaning as much as sound. Classic names carry generations of intention, and there is real elegance in choosing something timeless.',
          traits: ['Timeless', 'Rooted in faith', 'Generational']
        },
        rare: {
          icon: '\u25c7',
          validation: 'You want a name that feels distinctive without feeling invented. Beauty, meaning and a thoughtful origin matter more to you than simply following what is popular.',
          traits: ['Distinctive', 'Meaning-led', 'Thoughtful']
        },
        international: {
          icon: '\u25c9',
          validation: 'You are choosing with both heart and real life in mind. The right name should feel Muslim-friendly, beautiful and natural to pronounce across the cultures your child will move through.',
          traits: ['Cross-cultural', 'Easy to pronounce', 'Muslim-friendly']
        },
        balanced: {
          icon: '\u2734',
          validation: 'Your answers show a beautifully balanced instinct. You are weighing meaning, faith-fit, sound and everyday ease together rather than compromising on what matters most.',
          traits: ['Well-rounded', 'Meaningful', 'Made for real life']
        },
        classicRare: {
          icon: '\u2727',
          validation: 'Your style says a lot about you \u2014 you care about meaning as much as sound. Classic names carry generations of intention, while a rarer choice lets that timeless beauty feel distinctly yours.',
          traits: ['Timeless', 'Distinctive', 'Meaning-led']
        }
      };
      const normalizedResult = result.toLowerCase();
      let profileKey = 'balanced';
      if (normalizedResult.includes('classic') && normalizedResult.includes('rare')) profileKey = 'classicRare';
      else if (normalizedResult.includes('international')) profileKey = 'international';
      else if (normalizedResult.includes('classic')) profileKey = 'classic';
      else if (normalizedResult.includes('rare')) profileKey = 'rare';
      else if (normalizedResult.includes('soft')) profileKey = 'soft';
      const profile = resultProfiles[profileKey];
      const resultNode = root.querySelector('[data-bb-result]');
      if (resultNode) resultNode.textContent = result;
      const symbol = root.querySelector('[data-bb-result-symbol]');
      const validation = root.querySelector('[data-bb-validation]');
      if (symbol) symbol.textContent = profile.icon;
      if (validation) validation.textContent = profile.validation;
      const revealItems = root.querySelectorAll('.bb-result-page__copy [data-bb-reveal]');
      revealItems.forEach((item, index) => {
        item.style.setProperty('--bb-delay', `${index * 240}ms`);
        item.classList.add('is-visible');
      });
      const ctaCopy = root.querySelector('[data-bb-cta-copy]');
      const preferences = [params.get('origins'), params.get('style')].filter(Boolean).join(', ');
      if (ctaCopy && preferences) {
        ctaCopy.textContent = `Based on what you shared — ${preferences} — we can turn that into a focused shortlist of 10 names, with the meaning, origin and reason each one fits. No more scrolling through the same lists.`;
      }
      const recap = root.querySelector('[data-bb-recap]');
      [
        ['\u2661', 'Meanings', 'meaning_preferences'],
        ['\u25ce', 'Origins', 'origins'],
        ['\u224b', 'Style', 'style'],
        ['\u25c7', 'Avoidances', 'avoidances']
      ].forEach(([icon, label, key], index) => {
        const value = params.get(key);
        if (!value) return;
        const line = document.createElement('div');
        line.className = 'bb-recap__line is-visible';
        line.dataset.bbReveal = '';
        line.style.setProperty('--bb-delay', `${720 + index * 240}ms`);
        const iconNode = document.createElement('span');
        iconNode.className = 'bb-recap__icon';
        iconNode.setAttribute('aria-hidden', 'true');
        iconNode.textContent = icon;
        const labelNode = document.createElement('strong');
        labelNode.className = 'bb-recap__label';
        labelNode.textContent = label;
        const valueNode = document.createElement('span');
        valueNode.className = 'bb-recap__value';
        valueNode.textContent = value;
        line.append(iconNode, labelNode, valueNode);
        recap.appendChild(line);
      });
      if (recap && !recap.children.length) recap.previousElementSibling.hidden = true;
      const shareCard = root.querySelector('[data-bb-share-card]');
      const shareIcon = root.querySelector('[data-bb-share-icon]');
      const shareTitle = root.querySelector('[data-bb-share-title]');
      const shareTraits = root.querySelector('[data-bb-share-traits]');
      const shareStatus = root.querySelector('[data-bb-share-status]');
      if (shareIcon) shareIcon.textContent = profile.icon;
      if (shareTitle) shareTitle.textContent = result;
      if (shareTraits) {
        profile.traits.forEach((trait) => {
          const traitNode = document.createElement('span');
          traitNode.textContent = trait;
          shareTraits.appendChild(traitNode);
        });
      }
      if (shareCard) {
        shareCard.style.setProperty('--bb-delay', '1760ms');
        shareCard.classList.add('is-visible');
      }
      const createShareImage = () => new Promise((resolve) => {
        const canvas = document.createElement('canvas');
        canvas.width = 1080;
        canvas.height = 1080;
        const context = canvas.getContext('2d');
        context.fillStyle = '#f8f3ee';
        context.fillRect(0, 0, 1080, 1080);
        context.strokeStyle = '#d5bda8';
        context.lineWidth = 3;
        context.strokeRect(54, 54, 972, 972);
        context.fillStyle = '#6f4628';
        context.beginPath();
        context.arc(540, 250, 104, 0, Math.PI * 2);
        context.fill();
        context.fillStyle = '#ffffff';
        context.font = '108px serif';
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.fillText(profile.icon, 540, 250);
        context.fillStyle = '#8c5a31';
        context.font = '700 30px sans-serif';
        context.fillText('YOUR BABYBARAKA NAME STYLE', 540, 420);
        context.fillStyle = '#21150f';
        context.font = '700 62px sans-serif';
        const words = result.split(' ');
        const lines = [];
        let line = '';
        words.forEach((word) => {
          const testLine = line ? `${line} ${word}` : word;
          if (context.measureText(testLine).width > 820 && line) {
            lines.push(line);
            line = word;
          } else {
            line = testLine;
          }
        });
        lines.push(line);
        lines.forEach((titleLine, index) => context.fillText(titleLine, 540, 530 + index * 76));
        context.font = '600 30px sans-serif';
        context.fillStyle = '#6f4628';
        context.fillText(profile.traits.join('  \u2022  '), 540, 760);
        context.font = '700 24px sans-serif';
        context.fillStyle = '#8a7567';
        context.fillText('babybaraka.com', 540, 970);
        canvas.toBlob(resolve, 'image/png');
      });
      const saveCard = async () => {
        const blob = await createShareImage();
        if (!blob) return;
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'my-babybaraka-name-style.png';
        link.click();
        URL.revokeObjectURL(link.href);
        if (shareStatus) shareStatus.textContent = 'Your result card is ready to share.';
      };
      const shareResult = async () => {
        const blob = await createShareImage();
        if (!blob) return;
        const file = new File([blob], 'my-babybaraka-name-style.png', { type: 'image/png' });
        if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
          try {
            await navigator.share({
              title: `My BabyBaraka style: ${result}`,
              text: `My baby-name style is ${result}.`,
              files: [file]
            });
            if (shareStatus) shareStatus.textContent = 'Thanks for sharing your result.';
          } catch (error) {
            if (error.name !== 'AbortError' && shareStatus) shareStatus.textContent = 'Sharing was not available. Try saving the card instead.';
          }
          return;
        }
        await saveCard();
      };
      const saveButton = root.querySelector('[data-bb-save-card]');
      const shareButton = root.querySelector('[data-bb-share-card-button]');
      if (saveButton) saveButton.addEventListener('click', saveCard);
      if (shareButton) shareButton.addEventListener('click', shareResult);
      const forward = root.querySelector('[data-bb-forward]');
      if (forward) forward.href = `/pages/babybaraka-shortlist-offer${window.location.search}`;
    };
    document.querySelectorAll('[data-bb-result-page]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-bb-result-page]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["babybaraka-salwa-conversation"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    const RESULT_STYLES = {
      classic: {
        label: 'Classic & Timeless',
        line: "You're drawn to names with a strong, familiar Muslim identity — names that have been carried beautifully for generations and never feel dated."
      },
      rare: {
        label: 'Rare & Meaningful',
        line: "You're looking for something a little different — a name with a beautiful meaning that still feels natural and easy to carry."
      },
      international: {
        label: 'Easy & International',
        line: "You want a name that's beautiful and unmistakably Muslim, but also comfortable to say and spell wherever your family lives."
      },
      soft: {
        label: 'Soft & Modern',
        line: "You're drawn to gentle, modern names — warm sounding, easy to say, and lovely for your child to carry every day."
      },
      balanced: {
        label: 'Balanced & Complete',
        line: "You want the whole picture — meaning, sound, pronunciation and a name that feels right for your family, all at once."
      }
    };

    const TASTER = {
      female: [
        { n: 'Amina', m: 'Trustworthy, faithful', o: 'Arabic', s: ['classic','balanced'], r: ['arabic','maghrebi','african','south_asian'] },
        { n: 'Maryam', m: 'The Arabic form of Mary — the only woman named in the Qur’an', o: 'Arabic', s: ['classic','balanced'], r: ['arabic','maghrebi','turkish_persian','south_asian','african'] },
        { n: 'Iman', m: 'Faith', o: 'Arabic', s: ['classic','soft'], r: ['arabic','african','maghrebi'] },
        { n: 'Rahma', m: 'Mercy', o: 'Arabic', s: ['classic','rare'], r: ['arabic','maghrebi'] },
        { n: 'Salma', m: 'Safe, at peace', o: 'Arabic', s: ['soft','classic'], r: ['arabic','maghrebi'] },
        { n: 'Noor', m: 'Light', o: 'Arabic', s: ['soft','international','balanced'], r: ['arabic','maghrebi','south_asian','african','turkish_persian'] },
        { n: 'Hana', m: 'Contentment, happiness', o: 'Arabic', s: ['soft','international'], r: ['arabic','turkish_persian'] },
        { n: 'Layla', m: 'Night', o: 'Arabic', s: ['soft','international'], r: ['arabic','maghrebi','african','south_asian'] },
        { n: 'Yasmin', m: 'The jasmine flower', o: 'Persian, used across the Arab world', s: ['soft','international'], r: ['arabic','turkish_persian','maghrebi'] },
        { n: 'Zaynab', m: 'A fragrant flowering plant — the name of a daughter of the Prophet ﷺ', o: 'Arabic', s: ['classic'], r: ['arabic','south_asian','african'] },
        { n: 'Sakina', m: 'Tranquillity — the calm described in the Qur’an', o: 'Arabic', s: ['rare','classic'], r: ['arabic','south_asian'] },
        { n: 'Bushra', m: 'Good news, glad tidings', o: 'Arabic', s: ['rare'], r: ['arabic'] },
        { n: 'Safiyya', m: 'Pure, chosen', o: 'Arabic', s: ['classic','rare'], r: ['arabic','african'] },
        { n: 'Inaya', m: 'Care, protection', o: 'Arabic', s: ['soft','rare'], r: ['arabic','south_asian'] },
        { n: 'Malak', m: 'Angel', o: 'Arabic', s: ['soft'], r: ['arabic','maghrebi'] },
        { n: 'Zahra', m: 'Radiant, blossoming', o: 'Arabic', s: ['classic','soft'], r: ['arabic','maghrebi','african'] },
        { n: 'Amira', m: 'Princess, one who leads', o: 'Arabic', s: ['soft','international'], r: ['arabic','maghrebi','south_asian','african'] },
        { n: 'Sumayya', m: 'Elevated — the name of the first martyr in Islam', o: 'Arabic', s: ['rare','classic'], r: ['arabic','african'] },
        { n: 'Aaliyah', m: 'Exalted, high', o: 'Arabic', s: ['international','soft'], r: ['arabic','african','south_asian','maghrebi'] },
        { n: 'Sana', m: 'Radiance, brilliance', o: 'Arabic', s: ['rare','international'], r: ['arabic','south_asian'] },
        { n: 'Elif', m: 'Alif, the first letter of the Arabic alphabet — a symbol of oneness', o: 'Turkish', s: ['rare','soft'], r: ['turkish_persian'] },
        { n: 'Zeynep', m: 'The Turkish form of Zaynab', o: 'Turkish', s: ['classic'], r: ['turkish_persian'] },
        { n: 'Leyla', m: 'Night', o: 'Turkish and Persian', s: ['soft','international'], r: ['turkish_persian'] },
        { n: 'Kenza', m: 'Treasure', o: 'Amazigh / North African', s: ['rare'], r: ['maghrebi'] },
        { n: 'Imane', m: 'Faith — the North African spelling of Iman', o: 'North African', s: ['classic','international'], r: ['maghrebi'] },
        { n: 'Mahira', m: 'Skilled, capable', o: 'Arabic', s: ['rare'], r: ['south_asian','arabic'] }
      ],
      male: [
        { n: 'Yusuf', m: 'The Arabic form of Joseph — a prophet honoured in the Qur’an', o: 'Arabic', s: ['classic','balanced'], r: ['arabic','maghrebi','turkish_persian','south_asian','african'] },
        { n: 'Ibrahim', m: 'The Arabic form of Abraham — the prophet called the friend of God', o: 'Arabic', s: ['classic'], r: ['arabic','maghrebi','turkish_persian','south_asian','african'] },
        { n: 'Adam', m: 'The first human being created by God', o: 'Arabic', s: ['classic','international'], r: ['arabic','maghrebi','turkish_persian','south_asian','african'] },
        { n: 'Musa', m: 'The Arabic form of Moses', o: 'Arabic', s: ['classic'], r: ['arabic','african','south_asian'] },
        { n: 'Idris', m: 'A prophet named in the Qur’an', o: 'Arabic', s: ['rare','classic'], r: ['arabic','african','maghrebi'] },
        { n: 'Ilyas', m: 'The Arabic form of Elijah', o: 'Arabic', s: ['rare'], r: ['arabic','turkish_persian','south_asian'] },
        { n: 'Zakariya', m: 'The Arabic form of Zechariah', o: 'Arabic', s: ['rare','classic'], r: ['arabic','south_asian'] },
        { n: 'Hamza', m: 'Lion, strong — the name of the Prophet’s ﷺ uncle', o: 'Arabic', s: ['classic'], r: ['arabic','maghrebi','turkish_persian','south_asian'] },
        { n: 'Bilal', m: 'The first muezzin of Islam', o: 'Arabic', s: ['classic','international'], r: ['arabic','maghrebi','african','south_asian'] },
        { n: 'Omar', m: 'Flourishing, long-lived', o: 'Arabic', s: ['classic','international'], r: ['arabic','maghrebi','turkish_persian'] },
        { n: 'Ali', m: 'Elevated, exalted', o: 'Arabic', s: ['classic','international'], r: ['arabic','maghrebi','turkish_persian','south_asian','african'] },
        { n: 'Amir', m: 'Prince, one who leads', o: 'Arabic', s: ['international','soft'], r: ['arabic','maghrebi','south_asian'] },
        { n: 'Karim', m: 'Generous, noble', o: 'Arabic', s: ['classic','soft'], r: ['arabic','maghrebi','african'] },
        { n: 'Rayyan', m: 'Lush and well-watered — also the name of a gate of Paradise for those who fast', o: 'Arabic', s: ['rare','soft'], r: ['arabic','maghrebi','south_asian'] },
        { n: 'Zayd', m: 'Growth, abundance', o: 'Arabic', s: ['rare','classic'], r: ['arabic','south_asian'] },
        { n: 'Anas', m: 'Warm companionship, friendliness', o: 'Arabic', s: ['rare','soft'], r: ['arabic','maghrebi'] },
        { n: 'Salim', m: 'Safe, sound, whole', o: 'Arabic', s: ['classic','international'], r: ['arabic','african'] },
        { n: 'Nabil', m: 'Noble, honourable', o: 'Arabic', s: ['soft','classic'], r: ['arabic','maghrebi'] },
        { n: 'Sami', m: 'Elevated, sublime', o: 'Arabic', s: ['soft','international'], r: ['arabic','maghrebi'] },
        { n: 'Tariq', m: 'The morning star — the title of a surah of the Qur’an', o: 'Arabic', s: ['rare'], r: ['arabic','south_asian','maghrebi'] },
        { n: 'Yasin', m: 'The name of a surah of the Qur’an', o: 'Arabic', s: ['rare','classic'], r: ['arabic','turkish_persian','south_asian'] },
        { n: 'Ismail', m: 'The Arabic form of Ishmael', o: 'Arabic', s: ['classic'], r: ['arabic','maghrebi','turkish_persian','african'] },
        { n: 'Khalil', m: 'Close, devoted friend', o: 'Arabic', s: ['soft','classic'], r: ['arabic','african'] },
        { n: 'Imran', m: 'The family of Imran is honoured in the Qur’an', o: 'Arabic', s: ['classic'], r: ['south_asian','arabic'] },
        { n: 'Emir', m: 'The Turkish form of Amir — prince, one who leads', o: 'Turkish', s: ['international','soft'], r: ['turkish_persian'] },
        { n: 'Kerem', m: 'Generosity, nobility', o: 'Turkish', s: ['rare','soft'], r: ['turkish_persian'] },
        { n: 'Mehdi', m: 'Rightly guided', o: 'North African and Persian', s: ['classic'], r: ['maghrebi','turkish_persian'] },
        { n: 'Ayoub', m: 'The Arabic form of Job — the prophet known for patience', o: 'North African spelling', s: ['classic'], r: ['maghrebi','arabic'] },
        { n: 'Younes', m: 'The Arabic form of Jonah', o: 'North African spelling', s: ['classic','rare'], r: ['maghrebi','arabic'] },
        { n: 'Saif', m: 'Sword', o: 'Arabic', s: ['rare'], r: ['arabic','south_asian'] }
      ]
    };

    const REGION_MAP = [
      { key: 'arabic', match: ['arabic'] },
      { key: 'maghrebi', match: ['north african', 'maghrebi'] },
      { key: 'turkish_persian', match: ['turkish', 'persian'] },
      { key: 'south_asian', match: ['south asian'] },
      { key: 'african', match: ['african'] }
    ];

    const CONCERNS = [
      {
        key: 'partner',
        match: ['husband or family disagrees', 'arguments with family'],
        ack: "And I noticed agreeing on a name with your partner hasn’t been easy 😅 You’re not the only one — it’s the single most common thing people tell us.",
        bridge: "So in your case we’d deliberately include a few names that sit in the middle ground — ones that are easy for both of you to say yes to, instead of one of you giving in 🤍"
      },
      {
        key: 'lists',
        match: ['too many lists'],
        ack: "It also sounds like you’ve already been through a LOT of names 😅 And honestly, the 500th name doesn’t make the decision easier — it just makes it louder.",
        bridge: "So we don’t add to the pile. We take everything you just told us and narrow it down to ten, so you’re only choosing between names that already passed your own filter 🤍"
      },
      {
        key: 'meaning',
        match: ['trust meanings online', 'wrong meaning'],
        ack: "You also said you don’t fully trust the meanings you find online — and you’re right to be careful. The same name gets three different meanings on three different sites.",
        bridge: "So for you we check every meaning and origin properly and explain where it actually comes from, instead of handing you a one-word translation 🤍"
      },
      {
        key: 'regret',
        match: ['regretting the name later'],
        ack: "And I noticed you’re worried about choosing something you might regret. That’s fair — this is a name your child carries for life, in every classroom and on every document.",
        bridge: "So we give you enough context on each name that you can sit with it for a few days. The goal is a decision you feel settled about, not a fast one 🤍"
      },
      {
        key: 'pronunciation',
        match: ['correcting pronunciation', 'easy to carry in the west', 'easy pronunciation'],
        ack: "I also noticed you want a name that’s unmistakably yours, but that your child won’t spend their whole life spelling out at the doctor’s office.",
        bridge: "So we test each name for how it actually travels day to day — how it sounds, how it’s written, how a teacher will read it out loud 🤍"
      },
      {
        key: 'common',
        match: ['too common', 'rare not random'],
        ack: "And you’d rather not end up with a name that’s already in every classroom — but nothing invented either.",
        bridge: "So we look for names with real roots and real history that simply haven’t been overused. Rare, not random 🤍"
      }
    ];

    const JOURNEY_NUDGES = [
      { key: 'soon', match: ['baby is coming soon', 'coming soon'], line: "You mentioned baby is coming soon 🤍 The earlier you start, the more time you get to live with the names before you commit to one." },
      { key: 'here', match: ['baby is already here', 'already here'], line: "You mentioned baby is already here 🤍 That’s exactly why we work fast — your shortlist is with you within {H} hours, not next week." },
      { key: 'time', match: ['pregnant and still have time', 'still have time'], line: "You still have time, which is honestly the best moment to do this 🤍 You get to choose calmly instead of under pressure in the final weeks." },
      { key: 'planning', match: ['planning for the future', 'planning'], line: "You’re planning ahead 🤍 Having the shortlist ready now means the decision is already made when the time comes." }
    ];

    const norm = (value) => String(value || '')
      .toLowerCase()
      .replace(/[’']/g, ' ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

    const clean = (value) => value
      ? String(value).replace(/[|_]+/g, ', ').replace(/\s*,\s*/g, ', ').trim()
      : '';

    const ESC_KEYS = ['&', '<', '>', String.fromCharCode(34), String.fromCharCode(39)];
    const ESC_VALS = ['&#38;', '&#60;', '&#62;', '&#34;', '&#39;'];
    const ESC_RE = new RegExp('[&<>' + String.fromCharCode(34) + String.fromCharCode(39) + ']', 'g');
    const esc = (value) => String(value == null ? '' : value).replace(ESC_RE, (c) => ESC_VALS[ESC_KEYS.indexOf(c)]);

    const cdn = (url, width) => {
      if (!url || url.indexOf('cdn.shopify.com') === -1) return url;
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    };

    const titleCase = (value) => String(value || '').trim().replace(/^./, (c) => c.toUpperCase());

    function readQuiz() {
      const params = new URLSearchParams(window.location.search);
      let stored = {};
      let raw = {};
      try { stored = JSON.parse(localStorage.getItem('babybaraka_quiz_answers')) || {}; } catch (e) { stored = {}; }
      try { raw = (JSON.parse(localStorage.getItem('bb-name-quiz-latest')) || {}).answers || {}; } catch (e) { raw = {}; }

      const listOf = (name) => {
        const value = raw[name];
        if (Array.isArray(value)) return value.join(', ');
        if (value) return String(value);
        const slugged = stored[name];
        if (Array.isArray(slugged)) return slugged.join(', ');
        return '';
      };

      const pick = (paramNames, storeName) => {
        for (const p of paramNames) {
          const value = clean(params.get(p));
          if (value) return value;
        }
        return listOf(storeName);
      };

      const data = {
        hasParams: params.get('bb_quiz_done') === '1' || !!params.get('quiz_result'),
        resultTitle: clean(params.get('quiz_result')) || stored.resultTitle || '',
        babyType: pick(['baby_type'], 'babyType'),
        journey: pick(['journey', 'baby_journey'], 'babyJourney'),
        styles: pick(['style'], 'nameStyles'),
        origins: pick(['origins'], 'origins'),
        priorities: pick(['priorities', 'priority'], 'priorities'),
        meanings: pick(['meaning_preferences'], 'meaningPreferences'),
        difficulties: pick(['difficulties', 'concern'], 'difficulties'),
        avoidances: pick(['avoidances'], 'avoidances'),
        initials: clean(params.get('initial_preferences')) || String(stored.initialPreferences || ''),
        selectedOffer: clean(params.get('selected_offer'))
      };

      data.known = !!(data.resultTitle || data.styles || data.difficulties || data.avoidances);
      return data;
    }

    function styleKeyFrom(hay) {
      if (!hay) return '';
      if (/classic|timeless/.test(hay)) return 'classic';
      if (/rare/.test(hay)) return 'rare';
      if (/international/.test(hay)) return 'international';
      if (/soft|elegant|refined|modern/.test(hay)) return 'soft';
      if (/balanced|premium/.test(hay)) return 'balanced';
      return '';
    }

    function styleFor(quiz) {
      const key = styleKeyFrom(norm(quiz.resultTitle)) || styleKeyFrom(norm(quiz.styles));
      if (key) return Object.assign({ key: key }, RESULT_STYLES[key]);
      if (quiz.resultTitle) {
        return {
          key: '',
          label: quiz.resultTitle.replace(/\s+Names$/i, '').trim(),
          line: "That’s the direction your answers point to — the kind of names that would suit what you’re looking for."
        };
      }
      return null;
    }

    function journeyNudgeFor(quiz, hours) {
      const hay = norm(quiz.journey);
      if (!hay) return null;
      const hit = JOURNEY_NUDGES.find((n) => n.match.some((m) => hay.indexOf(m) !== -1));
      return hit ? hit.line.replace('{H}', hours) : null;
    }

    function concernsFor(quiz) {
      const hay = [quiz.difficulties, quiz.avoidances, quiz.priorities].map(norm).join(' | ');
      return CONCERNS.filter((c) => c.match.some((m) => hay.indexOf(m) !== -1)).slice(0, 2);
    }

    function genderFor(quiz) {
      const hay = norm(quiz.babyType);
      if (hay.indexOf('girl') !== -1) return 'female';
      if (hay.indexOf('boy') !== -1) return 'male';
      return '';
    }

    function regionsFor(quiz) {
      const hay = norm(quiz.origins);
      if (!hay) return [];
      return REGION_MAP.filter((r) => r.match.some((m) => hay.indexOf(m) !== -1)).map((r) => r.key);
    }

    function seedFrom(quiz) {
      const source = [quiz.resultTitle, quiz.styles, quiz.origins, quiz.priorities, quiz.meanings, quiz.avoidances, quiz.babyType].join('|');
      let hash = 0;
      for (let i = 0; i < source.length; i += 1) {
        hash = ((hash << 5) - hash + source.charCodeAt(i)) | 0;
      }
      return Math.abs(hash);
    }

    function tasterFor(quiz, style) {
      const gender = genderFor(quiz) || (seedFrom(quiz) % 2 === 0 ? 'female' : 'male');
      const pool = TASTER[gender] || [];
      if (!pool.length) return null;

      const regions = regionsFor(quiz);
      const styleKey = style && style.key ? style.key : '';
      const letterMatch = norm(quiz.initials).match(/\b([a-z])\b/);
      const letter = letterMatch ? letterMatch[1] : '';

      const tiers = [
        (item) => (!regions.length || regions.some((r) => item.r.indexOf(r) !== -1)) && (!styleKey || item.s.indexOf(styleKey) !== -1),
        (item) => !regions.length || regions.some((r) => item.r.indexOf(r) !== -1),
        (item) => !styleKey || item.s.indexOf(styleKey) !== -1,
        () => true
      ];

      for (let t = 0; t < tiers.length; t += 1) {
        let candidates = pool.filter(tiers[t]);
        if (letter) {
          const withLetter = candidates.filter((item) => item.n.toLowerCase().charAt(0) === letter);
          if (withLetter.length) candidates = withLetter;
        }
        if (candidates.length) {
          return Object.assign({ gender: gender }, candidates[seedFrom(quiz) % candidates.length]);
        }
      }
      return null;
    }

    const init = (root) => {
      if (!root || root.dataset.bbReady === 'true') return;
      root.dataset.bbReady = 'true';

      let config = {};
      try { config = JSON.parse(root.querySelector('[data-bb-salwa-config]').textContent); } catch (e) { config = {}; }

      const thread = root.querySelector('[data-bb-thread]');
      const choices = root.querySelector('[data-bb-choices]');
      const errorNode = root.querySelector('[data-bb-error]');
      const stepNode = root.querySelector('[data-bb-step]');
      const zoom = root.querySelector('[data-bb-zoom]');
      const zoomImage = root.querySelector('[data-bb-zoom-image]');

      const quiz = readQuiz();
      const style = styleFor(quiz);
      const found = concernsFor(quiz);
      const hours = String(config.deliveryHours || '24').replace(/[^0-9]/g, '') || '24';
      const journeyNudge = journeyNudgeFor(quiz, hours);
      const taster = config.enableTaster === false ? null : tasterFor(quiz, style);
      const price = config.price || root.dataset.price || '';

      let lead = { firstName: '', email: '' };
      try {
        const savedLead = JSON.parse(localStorage.getItem('babybaraka_lead')) || {};
        if (savedLead && savedLead.email) lead = savedLead;
      } catch (e) {}

      const GUARANTEE_TITLE = 'Delivered in ' + hours + 'h, or your money back';
      const GUARANTEE_LINE = 'Your personalized shortlist is emailed within ' + hours + ' hours. If it is not, you get a full refund — no questions.';
      const GUARANTEE_HTML = '<div class="bb-guarantee"><i>✓</i><div>'
        + '<b>' + GUARANTEE_TITLE + '</b>'
        + '<small>' + GUARANTEE_LINE + '</small>'
        + '</div></div>';

      const hi = () => (lead.firstName ? esc(titleCase(lead.firstName)) + ', ' : '');

      function promoHTML() {
        if (!config.promoActive || !config.promoAfterPrice) return '';
        return '<div class="bb-promo"><span>⏳</span><span><b>Special offer</b> — this price until '
          + esc(config.promoDeadlineLabel) + ', then ' + esc(config.promoAfterPrice) + '.</span></div>';
      }

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const wait = (ms) => new Promise((resolve) => setTimeout(resolve, reduced ? 0 : ms));

      function setStep(text) {
        if (stepNode) stepNode.textContent = text || '';
      }

      function track(event, extra) {
        const payload = Object.assign({
          event: 'bb_' + event,
          bb_event: event,
          bb_result: quiz.resultTitle || '',
          bb_style: style ? style.label : '',
          bb_concerns: found.map((c) => c.key).join(',')
        }, extra || {});
        try { (window.dataLayer = window.dataLayer || []).push(payload); } catch (e) {}
        try { if (typeof window.gtag === 'function') window.gtag('event', 'bb_' + event, payload); } catch (e) {}
        try { if (typeof window.fbq === 'function') window.fbq('trackCustom', 'BB_' + event, payload); } catch (e) {}
        try { document.dispatchEvent(new CustomEvent('bb:track', { detail: payload })); } catch (e) {}
      }

      function standard(name, params) {
        try { if (typeof window.fbq === 'function') window.fbq('track', name, params || {}); } catch (e) {}
        try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) {}
      }

      function priceNumber() {
        const value = parseFloat(String(price).replace(/[^0-9.,]/g, '').replace(',', '.'));
        return isNaN(value) ? undefined : value;
      }

      function keepVisible(node) {
        const rect = node.getBoundingClientRect();
        if (rect.bottom > window.innerHeight - 140) {
          node.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'nearest' });
        }
      }

      function bubble(html, options) {
        const opts = options || {};
        const node = document.createElement('div');
        node.className = 'bb-msg bb-msg--' + (opts.from === 'me' ? 'me' : 'salwa') + (opts.wide ? ' bb-msg--wide' : '');
        node.innerHTML = html;
        thread.appendChild(node);
        keepVisible(node);
        return node;
      }

      async function typing(ms) {
        if (reduced || !ms) return;
        const node = document.createElement('div');
        node.className = 'bb-typing';
        node.innerHTML = '<i></i><i></i><i></i>';
        thread.appendChild(node);
        keepVisible(node);
        await wait(ms);
        node.remove();
      }

      async function salwa(html, options) {
        const opts = options || {};
        if (opts.think) await typing(opts.think);
        bubble(html, opts);
        await wait(opts.after !== undefined ? opts.after : 480);
      }

      function me(text) {
        bubble(esc(text), { from: 'me' });
      }

      function clearChoices() {
        choices.innerHTML = '';
      }

      function ask(options) {
        clearChoices();
        options.forEach((option, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'bb-btn' + (option.variant ? ' bb-btn--' + option.variant : '');
          button.textContent = option.label;
          button.style.animationDelay = (index * 60) + 'ms';
          button.addEventListener('click', () => {
            clearChoices();
            if (option.echo !== false) me(option.label);
            option.run();
          }, { once: true });
          choices.appendChild(button);
        });
      }

      async function start() {
        if (!style && !quiz.known) {
          await salwa("Hey 🤍 I don’t seem to have your quiz answers here — your browser may have cleared them.");
          await salwa("If you take the quiz again, I can show you your name style and build everything around your answers.", { after: 200 });
          ask([{
            label: 'Take the 2-minute quiz',
            variant: 'primary',
            echo: false,
            run: () => { window.location.href = config.quizUrl || '/pages/quiz-babybaraka'; }
          }]);
          return;
        }

        setStep('Your result');
        track('result_viewed');
        standard('ViewContent', { content_name: 'Post-quiz result', content_category: 'quiz' });

        await salwa('Hey 🤍 I’ve just gone through your answers.', { after: 560 });

        if (style) {
          await salwa(
            'Your baby name style is'
            + '<span class="bb-style"><span>Your name style</span><strong>' + esc(style.label) + ' ✨</strong></span>',
            { think: 620, after: 640 }
          );
          await salwa(esc(style.line), { after: 560 });
        }

        await recap();
      }

      async function recap() {
        const rows = [
          ['Style', quiz.styles],
          ['Origins', quiz.origins],
          ['Meanings', quiz.meanings],
          ['Matters most', quiz.priorities],
          ['To avoid', quiz.avoidances]
        ].filter((row) => row[1]);

        if (rows.length) {
          const html = 'This is what I wrote down for you 👇'
            + '<div class="bb-recap">'
            + rows.map((row) => '<div><b>' + esc(row[0]) + '</b><span>' + esc(row[1]) + '</span></div>').join('')
            + '</div>';
          await salwa(html, { wide: true, think: 500, after: 700 });
        }

        await acknowledge();
      }

      async function acknowledge() {
        for (let i = 0; i < found.length; i += 1) {
          await salwa(esc(found[i].ack), { think: 520, after: 620 });
        }

        if (!found.length) {
          await salwa("From all of that, what you’re really after is a name you can settle on with confidence — not another list to scroll through.", { after: 560 });
        }

        if (taster) {
          await gift();
          return;
        }

        await salwa('That’s exactly what we do here.<br>Would you like me to explain how?', { after: 120 });
        askExplain();
      }

      async function gift() {
        setStep('A first name');
        track('taster_shown', { bb_taster: taster.n });

        await salwa("Before anything else — here’s one name I’d already put on your list, for free 🤍", { think: 640, after: 620 });

        const chips = [];
        if (quiz.styles) chips.push(String(quiz.styles).split(',')[0].trim());
        if (quiz.origins) chips.push(String(quiz.origins).split(',')[0].trim());
        if (quiz.priorities) chips.push(String(quiz.priorities).split(',')[0].trim());

        const html = '<span class="bb-taster">'
          + '<u>Your first match</u>'
          + '<strong>' + esc(taster.n) + '</strong>'
          + '<i><b>Meaning:</b> ' + esc(taster.m) + '</i>'
          + '<s>Origin: ' + esc(taster.o) + '</s>'
          + (chips.length ? '<span class="bb-chips">' + chips.filter(Boolean).map((c) => '<em>' + esc(c) + '</em>').join('') + '</span>' : '')
          + '</span>';

        await salwa(html, { wide: true, after: 820 });
        await salwa('It’s yours to keep whether you buy anything or not 🤍', { after: 620 });
        await salwa('There are <strong>nine more</strong> that fit you just as well — and that’s the part I’d normally prepare for you by hand.', { after: 160 });

        if (config.enableEmailCapture !== false && !lead.email) {
          await emailStep(false);
          return;
        }

        askExplain();
      }

      function askExplain() {
        ask([
          { label: taster ? 'Show me the nine others 🤍' : 'Yes please 🤍', variant: 'primary', run: () => { track('help_yes'); explain(); } },
          { label: 'No, thank you', variant: 'ghost', run: () => { track('help_no'); decline(); } }
        ]);
      }

      async function emailStep(fromDecline) {
        setStep('Save your result');
        const askLine = config.emailAsk || 'Where should I send your name style and this first name, so you don’t lose them?';
        await salwa(esc(askLine), { after: 120 });

        clearChoices();
        const form = document.createElement('form');
        form.className = 'bb-form';
        form.noValidate = true;
        form.innerHTML = '<input type="text" name="first_name" autocomplete="given-name" placeholder="Your first name" aria-label="Your first name">'
          + '<input type="email" name="email" autocomplete="email" inputmode="email" required placeholder="you@example.com" aria-label="Your email address">'
          + '<button type="submit" class="bb-btn bb-btn--primary">Send it to me 🤍</button>'
          + '<small>One email with your result. No spam, unsubscribe any time.</small>';

        const skip = document.createElement('button');
        skip.type = 'button';
        skip.className = 'bb-btn bb-btn--ghost';
        skip.textContent = fromDecline ? 'No thanks' : 'Skip this step';

        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          const data = new FormData(form);
          const email = String(data.get('email') || '').trim();
          const firstName = String(data.get('first_name') || '').trim();
          if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
            errorNode.textContent = 'That email doesn’t look quite right — could you check it?';
            return;
          }
          errorNode.textContent = '';
          const submit = form.querySelector('button[type="submit"]');
          submit.disabled = true;
          submit.textContent = 'Saving…';

          lead = { firstName: firstName, email: email };
          try { localStorage.setItem('babybaraka_lead', JSON.stringify(lead)); } catch (e) {}
          await subscribe(lead);

          track('lead_captured');
          standard('Lead', { content_name: 'Post-quiz email capture' });

          clearChoices();
          me(email);
          await salwa('Got it ' + (firstName ? esc(titleCase(firstName)) + ' ' : '') + '🤍 It’s on its way to your inbox.', { after: 620 });
          if (fromDecline) {
            await farewell();
            return;
          }
          askExplain();
        });

        skip.addEventListener('click', async () => {
          clearChoices();
          track('lead_skipped');
          if (fromDecline) {
            await farewell();
            return;
          }
          askExplain();
        });

        choices.appendChild(form);
        choices.appendChild(skip);
      }

      async function subscribe(person) {
        try {
          const body = new URLSearchParams();
          body.append('form_type', 'customer');
          body.append('utf8', '✓');
          body.append('contact[email]', person.email);
          if (person.firstName) body.append('contact[first_name]', person.firstName);
          body.append('contact[tags]', ['babybaraka-quiz', quiz.resultTitle, style ? style.label : ''].filter(Boolean).join(','));
          await fetch('/contact', { method: 'POST', body: body, headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
        } catch (e) {}
      }

      async function decline() {
        await salwa('Of course 🤍 No pressure at all.', { after: 520 });
        if (config.enableEmailCapture !== false && !lead.email) {
          await salwa('Can I at least send you your result, so it isn’t lost when you close this page?', { after: 300 });
          await emailStep(true);
          return;
        }
        await farewell();
      }

      async function farewell() {
        if (style) {
          await salwa(
            '<span class="bb-style"><span>Your free name style result</span><strong>' + esc(style.label) + ' ✨</strong></span>'
            + '<p class="bb-note">' + esc(style.line) + '</p>',
            { wide: true, after: 420 }
          );
        }
        await salwa('Wishing you a beautiful pregnancy and all the best with your little one 🤍', { after: 260 });
        clearChoices();
        const back = document.createElement('button');
        back.type = 'button';
        back.className = 'bb-btn bb-btn--ghost';
        back.textContent = taster ? 'Actually, show me the nine other names' : 'Actually, tell me more';
        back.addEventListener('click', () => { clearChoices(); track('decline_reversed'); explain(); }, { once: true });
        choices.appendChild(back);
        setStep('');
      }

      async function explain() {
        setStep('What you get');
        await salwa(
          hi() + "here’s how it works. Instead of another endless list, we take the answers you just gave and build one shortlist around them.",
          { think: 560, after: 720 }
        );
        await salwa(
          "Ten names. Chosen for your style, your origins, the meanings you said matter, how each one is pronounced — and the exact concern you told me about.",
          { after: 700 }
        );

        if (found.length) {
          await salwa(esc(found[0].bridge), { think: 480, after: 700 });
        }

        track('offer_viewed');
        standard('ViewContent', { content_name: 'Shortlist offer', value: priceNumber(), currency: config.currency });

        await salwa(
          'Here’s exactly what lands in your inbox 🤍'
          + '<ul class="bb-included">'
          + '<li><i>✓</i><div><b>Your personalized 10-name shortlist</b><small>Each name with its meaning, its origin, and one line on why it fits what you told me. Sent within ' + hours + ' hours.</small></div></li>'
          + '<li><i>✓</i><div><b>One free refinement</b><small>If the first list isn’t quite right, tell us why and we rebuild it around your feedback. You can’t get this wrong.</small></div></li>'
          + '<li><i>✓</i><div><b>6 printable bonuses</b><small>Milestone cards, pregnancy planner, hospital bag list and more — downloadable the moment you order.</small></div></li>'
          + '</ul>'
          + '<div class="bb-price-line"><b>' + esc(price) + '</b><span>one-time payment · no subscription</span></div>'
          + promoHTML()
          + GUARANTEE_HTML,
          { wide: true, after: 820 }
        );

        await proof();
      }

      async function proof() {
        if (config.reviewText) {
          await salwa(
            '<span class="bb-review">'
            + '<span class="bb-stars">★★★★★</span>'
            + '<q>' + esc(config.reviewText) + '</q>'
            + '<cite><i>♥</i><span><b>' + esc(config.reviewAuthor || 'Verified customer') + '</b>'
            + (config.reviewMeta ? '<small>' + esc(config.reviewMeta) + '</small>' : '') + '</span></cite>'
            + '</span>',
            { wide: true, think: 520, after: 780 }
          );
        }

        await salwa(
          'And in case you’re wondering: <strong>this isn’t spat out by a machine.</strong> Your list is put together by hand — every meaning and origin checked before it reaches you.',
          { after: 700 }
        );

        await salwa('Want to see what a real shortlist actually looks like first?', { after: 120 });
        ask([
          { label: 'Yes, show me 🤍', variant: 'primary', run: () => { track('example_yes'); showExample(); } },
          { label: 'I’ve seen enough', run: () => { track('example_no'); goCheckout(); } }
        ]);
      }

      async function showExample() {
        setStep('A real example');
        const video = config.shortlistVideo || '';
        const pages = (config.shortlistPages || []).filter(Boolean);

        if (video) {
          const html = '<div class="bb-shortlist-video">'
            + '<video controls muted playsinline preload="metadata" data-bb-shortlist-video'
            + (config.shortlistPoster ? ' poster="' + esc(config.shortlistPoster) + '"' : '')
            + '><source src="' + esc(video) + '" type="video/mp4"></video></div>'
            + '<p class="bb-note">Press play to see a full shortlist, page by page. This is a real customer example — not your list.</p>';
          await salwa(html, { wide: true, after: 820 });
        } else if (pages.length) {
          const html = '<div class="bb-pages">' + pages.map((src, index) =>
            '<button type="button" data-bb-page aria-label="Enlarge example page ' + (index + 1) + '">'
            + '<img src="' + esc(cdn(src, 700)) + '" data-full="' + esc(cdn(src, 1600)) + '" loading="lazy" decoding="async" alt="Example page ' + (index + 1) + ' of a personalized BabyBaraka shortlist">'
            + '<b>Tap to enlarge</b></button>'
          ).join('') + '</div>'
          + '<p class="bb-note">Tap either page to see it full size. This is a real customer example — not your list.</p>';
          await salwa(html, { wide: true, after: 820 });
        }

        await salwa(
          'Yours will look like this 🤍 — with <strong>' + esc(taster ? taster.n : 'your first match') + '</strong> and nine more chosen from what you told me today.',
          { after: 720 }
        );

        const bonuses = (config.bonuses || []).filter((b) => b && b.image);
        if (bonuses.length) {
          await salwa('And these six printables come with it, free ✨', { after: 420 });
          const watch = video
            ? '<button type="button" class="bb-watch" data-bb-watch><span aria-hidden="true">↑</span> Watch in video</button>'
            : '';
          const rail = '<div class="bb-bonus-rail">' + bonuses.map((b) =>
            '<figure><button type="button" data-bb-page aria-label="Enlarge ' + esc(b.title) + '">'
            + '<img src="' + esc(cdn(b.image, 460)) + '" data-full="' + esc(cdn(b.image, 1400)) + '" loading="lazy" decoding="async" alt="' + esc(b.title) + '">'
            + '</button><figcaption>' + esc(b.title) + '</figcaption>' + watch + '</figure>'
          ).join('') + '</div>'
          + '<p class="bb-note">Tap any bonus to see it full size. All six are printable and emailed instantly after your order.</p>';
          await salwa(rail, { wide: true, after: 620 });
        }

        goCheckout();
      }

      async function goCheckout() {
        setStep('Last step');
        if (journeyNudge) {
          await salwa(esc(journeyNudge), { after: 640 });
        }
        if (config.promoActive && config.promoAfterPrice) {
          await salwa(
            'And it’s ' + esc(price) + ' until ' + esc(config.promoDeadlineLabel)
            + ' 🤍 After that it goes back to ' + esc(config.promoAfterPrice) + '.',
            { after: 560 }
          );
        }
        await salwa('Whenever you’re ready ' + (lead.firstName ? esc(titleCase(lead.firstName)) + ' ' : '') + '🤍', { after: 260 });
        root.classList.add('is-checkout');
        standard('InitiateCheckout', { value: priceNumber(), currency: config.currency, num_items: 1 });

        clearChoices();
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'bb-btn bb-btn--primary';
        button.innerHTML = 'Send me my 10 names — <span class="bb-nowrap">' + esc(price) + '</span>';
        button.addEventListener('click', () => buy(button));
        choices.appendChild(button);

        const guarantee = document.createElement('div');
        guarantee.className = 'bb-guarantee bb-guarantee--solo';
        guarantee.innerHTML = '<i>✓</i><div><b>' + GUARANTEE_TITLE + '</b><small>' + GUARANTEE_LINE + '</small></div>';
        choices.appendChild(guarantee);

        const note = document.createElement('small');
        note.className = 'bb-note';
        note.style.textAlign = 'center';
        note.textContent = 'Secure checkout · one-time payment · digital delivery';
        choices.appendChild(note);
      }

      function orderProperties() {
        const entries = {
          'BabyBaraka quiz result': quiz.resultTitle,
          'BabyBaraka selected offer': quiz.selectedOffer,
          'BabyBaraka baby': quiz.babyType,
          'BabyBaraka journey': quiz.journey,
          'BabyBaraka style': quiz.styles,
          'BabyBaraka origins': quiz.origins,
          'BabyBaraka priorities': quiz.priorities,
          'BabyBaraka meaning': quiz.meanings,
          'BabyBaraka concern': quiz.difficulties,
          'BabyBaraka avoid': quiz.avoidances,
          'BabyBaraka initials': quiz.initials,
          'BabyBaraka first name': lead.firstName,
          'BabyBaraka free match': taster ? taster.n : ''
        };
        return Object.fromEntries(Object.entries(entries).filter((pair) => pair[1]));
      }

      async function buy(button) {
        const variantId = Number(config.variantId);
        if (!variantId) return;
        const original = button.innerHTML;
        button.disabled = true;
        button.textContent = 'Opening secure checkout…';
        errorNode.textContent = '';
        track('checkout_clicked', { bb_price: price, bb_currency: config.currency });

        try {
          await fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1, properties: orderProperties() })
          });
          if (!response.ok) throw new Error('cart');
          window.location.href = '/checkout';
        } catch (e) {
          button.disabled = false;
          button.innerHTML = original;
          errorNode.textContent = 'Something went wrong. Please try again.';
        }
      }

      thread.addEventListener('click', (event) => {
        const watchTrigger = event.target.closest('[data-bb-watch]');
        if (watchTrigger) {
          const player = thread.querySelector('[data-bb-shortlist-video]');
          if (!player) return;
          player.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
          try { player.play(); } catch (e) {}
          return;
        }

        const trigger = event.target.closest('[data-bb-page]');
        if (!trigger || !zoom || !zoomImage) return;
        const image = trigger.querySelector('img');
        if (!image) return;
        zoomImage.src = image.getAttribute('data-full') || image.currentSrc || image.src;
        zoomImage.alt = image.alt;
        if (typeof zoom.showModal === 'function') zoom.showModal();
      });
      const closeBtn = root.querySelector('[data-bb-zoom-close]');
      if (closeBtn) closeBtn.addEventListener('click', () => { if (zoom) zoom.close(); });
      if (zoom) zoom.addEventListener('click', (event) => { if (event.target === zoom) zoom.close(); });

      start();
    };

    const boot = () => document.querySelectorAll('[data-bb-salwa]').forEach(init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', (event) => {
      const node = event.target.querySelector ? event.target.querySelector('[data-bb-salwa]') : null;
      if (node) { node.dataset.bbReady = ''; init(node); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isTransparent = document.querySelector('.header-wrapper').classList.contains('transparent-header');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          this.header.classList.remove('transparent-header');
          if (scrollTop > this.currentScrollTop) {
            this.header.classList.add('shopify-section-header-hidden');
          } else {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        } else {
          this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
          this.header.classList.add('transparent-header');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close()); 
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    

class VideoGallery extends HTMLElement {
  constructor() {
    super();
    this.deferredMedia = this.querySelector(".video-gallery__media");
    this.videoPlaylist = this.querySelector(".video-gallery__thumbnails");
    this.activeVideoTitle = this.querySelector(".video-gallery__active-video-title");
    this.videoPlayer = null;

    this.handleVideoClick = this.handleVideoClick.bind(this);
  }

  connectedCallback() {
    this.videoPlaylist.addEventListener("click", this.handleVideoClick);
  }

  disconnectedCallback() {
    this.videoPlaylist.removeEventListener("click", this.handleVideoClick);
  }

  getVideoEmbedRef = () => {
    return document.querySelector('.video-gallery__embed');
  }

  getVideoPlayerRef = () => {
    return document.querySelector('.video-gallery__player');
  }

  clearExistingMedia = (type) => {
    
    const existingEmbed = this.getVideoEmbedRef();
    const existingPlayer = this.getVideoPlayerRef();

    if (type === 'video' && existingEmbed) {
      existingEmbed.remove();
    }

    if (type === 'embed' && existingPlayer) {
      existingPlayer.remove();
    }
  }

  handleVideoClick = (e) => {

    const thumbnailElement = event.target.closest(".video-gallery__thumbnail");
    if (!thumbnailElement) {
      console.error('Thumbnail element not found');
      return;
    }
    
    if (this.deferredMedia) {
      this.deferredMedia.loadContent(false);
    }

    const videoURL = thumbnailElement.dataset.videoUrl;
    const embedType = thumbnailElement.dataset.embedUrlType;
    const embedID = thumbnailElement.dataset.embedUrlId;
    const videoTitle = thumbnailElement.dataset.videoTitle;
    
    if (videoURL) {
        // Load video
        this.loadVideo(videoURL, videoTitle);
    } else if (embedType && embedID) {
        // Load embed
        this.loadEmbed(embedType, embedID, videoTitle);
    } else {
        console.error('Video URL or embed URL not found');
    }

    this.scrollToVideoPlayer(); 
  }

  // Function to scroll to the video player
  scrollToVideoPlayer = () => {
    if (!this.videoPlayer) {
      console.error('Video player element not found');
      return;
    }

    const videoPlayerPosition = this.videoPlayer.getBoundingClientRect().top + window.scrollY - 150;

    window.scrollTo({
      top: videoPlayerPosition,
      behavior: 'smooth'
    });
  }

  loadVideo = (videoURL, videoTitle) => {

    this.clearExistingMedia('video');

    // Get the video player
    this.videoPlayer = this.getVideoPlayerRef();

    if (!this.videoPlayer) {
      console.log('Video player element not found, creating it');
      this.videoPlayer = document.createElement('video');
      this.videoPlayer.classList.add('video-gallery__player');
      this.videoPlayer.setAttribute('playsinline', '');
      this.videoPlayer.setAttribute('autoplay', '');
      this.videoPlayer.setAttribute('controls', '');

      this.deferredMedia.appendChild(this.videoPlayer);
    }
    
    // Set video source and title
    this.videoPlayer.src = videoURL;
    this.videoPlayer.load();

    // Play the video
    this.videoPlayer.addEventListener('loadedmetadata', function loadedMetadataHandler() {
      this.videoPlayer.play()
        .then(() => {
          console.log('Video started playing');
          // Remove the event listener after playback starts
          this.videoPlayer.removeEventListener('loadedmetadata', loadedMetadataHandler);
        })
        .catch((error) => {
          console.error('Error playing video:', error);
        });
    }.bind(this));

    // Update the active video title
    this.activeVideoTitle.innerText = videoTitle;
  }

  loadEmbed = (embedType, embedID, videoTitle) => {

    if (embedType !== 'youtube' && embedType !== 'vimeo') {
      console.error('Invalid embed type');
      return;
    }

    this.clearExistingMedia('embed');

    const embedURL = (embedType == 'youtube') ? `https://www.youtube.com/embed/${embedID}?autoplay=1`: `https://player.vimeo.com/video/${videoId}?autoplay=1`;

    let embedElement = this.getVideoEmbedRef();

    if (!embedElement) {
      embedElement = document.createElement('iframe');
      embedElement.classList.add('video-gallery__embed');
      embedElement.setAttribute('allow', 'autoplay; encrypted-media');
      embedElement.setAttribute('allowfullscreen', '');
      this.deferredMedia.appendChild(embedElement);
    }
    
    embedElement.src = embedURL;
    embedElement.setAttribute('title', videoTitle);

    this.videoPlayer = embedElement;

    this.activeVideoTitle.innerText = videoTitle;
  }

}

customElements.define('video-gallery', VideoGallery);


  } catch(e) { console.error(e); }
})();
})();
